/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthenticatedRouteRouteImport } from './routes/_unauthenticated/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedSplatRouteImport } from './routes/_authenticated/$'
import { Route as AuthenticatedUserManagementRouteRouteImport } from './routes/_authenticated/userManagement/route'
import { Route as AuthenticatedProjectRouteRouteImport } from './routes/_authenticated/project/route'
import { Route as HomeModeIndexRouteImport } from './routes/home/$mode/index'
import { Route as UnauthenticatedSsoSelectionIndexRouteImport } from './routes/_unauthenticated/ssoSelection/index'
import { Route as UnauthenticatedSamlLoginIndexRouteImport } from './routes/_unauthenticated/samlLogin/index'
import { Route as UnauthenticatedRegisterIndexRouteImport } from './routes/_unauthenticated/register/index'
import { Route as UnauthenticatedLoginIndexRouteImport } from './routes/_unauthenticated/login/index'
import { Route as UnauthenticatedIdpSelectionIndexRouteImport } from './routes/_unauthenticated/idpSelection/index'
import { Route as AuthenticatedUserSettingsIndexRouteImport } from './routes/_authenticated/userSettings/index'
import { Route as AuthenticatedUpgradeIndexRouteImport } from './routes/_authenticated/upgrade/index'
import { Route as AuthenticatedReportTemplatesIndexRouteImport } from './routes/_authenticated/reportTemplates/index'
import { Route as AuthenticatedHomeIndexRouteImport } from './routes/_authenticated/home/index'
import { Route as AuthenticatedProjectProjectsRouteRouteImport } from './routes/_authenticated/project/_projects/route'
import { Route as AuthenticatedProjectProjectIdRouteRouteImport } from './routes/_authenticated/project/$projectId/route'
import { Route as HomeModeTokenIndexRouteImport } from './routes/home/$mode/$token/index'
import { Route as UnauthenticatedRegisterVerificationCodeIndexRouteImport } from './routes/_unauthenticated/register/verification-code/index'
import { Route as UnauthenticatedRegisterInvitedTokenIndexRouteImport } from './routes/_unauthenticated/register/$invitedToken/index'
import { Route as AuthenticatedUserManagementCompaniesIndexRouteImport } from './routes/_authenticated/userManagement/companies/index'
import { Route as AuthenticatedProjectProjectsIndexRouteImport } from './routes/_authenticated/project/_projects/index'
import { Route as AuthenticatedProjectProjectIdTasksRouteRouteImport } from './routes/_authenticated/project/$projectId/tasks/route'
import { Route as AuthenticatedProjectProjectIdReportsRouteRouteImport } from './routes/_authenticated/project/$projectId/reports/route'
import { Route as AuthenticatedProjectProjectIdMediaRouteRouteImport } from './routes/_authenticated/project/$projectId/media/route'
import { Route as AuthenticatedProjectProjectIdDatasetsRouteRouteImport } from './routes/_authenticated/project/$projectId/datasets/route'
import { Route as AuthenticatedProjectProjectIdPlansRouteRouteImport } from './routes/_authenticated/project/$projectId/_plans/route'
import { Route as UnauthenticatedActivateTypeTokenIndexRouteImport } from './routes/_unauthenticated/activate/$type/$token/index'
import { Route as AuthenticatedUserManagementFolderRestrictionUserIdIndexRouteImport } from './routes/_authenticated/userManagement/folderRestriction/$userId/index'
import { Route as AuthenticatedProjectProjectsRenameIndexRouteImport } from './routes/_authenticated/project/_projects/rename/index'
import { Route as AuthenticatedProjectProjectsNewfolderIndexRouteImport } from './routes/_authenticated/project/_projects/newfolder/index'
import { Route as AuthenticatedProjectProjectsNewIndexRouteImport } from './routes/_authenticated/project/_projects/new/index'
import { Route as AuthenticatedProjectProjectsCopyIndexRouteImport } from './routes/_authenticated/project/_projects/copy/index'
import { Route as AuthenticatedProjectProjectIdTeamIndexRouteImport } from './routes/_authenticated/project/$projectId/team/index'
import { Route as AuthenticatedProjectProjectIdTasksIndexRouteImport } from './routes/_authenticated/project/$projectId/tasks/index'
import { Route as AuthenticatedProjectProjectIdMediaIndexRouteImport } from './routes/_authenticated/project/$projectId/media/index'
import { Route as AuthenticatedProjectProjectIdGroupsIndexRouteImport } from './routes/_authenticated/project/$projectId/groups/index'
import { Route as AuthenticatedProjectProjectIdDatasetsIndexRouteImport } from './routes/_authenticated/project/$projectId/datasets/index'
import { Route as AuthenticatedProjectProjectIdPlansIndexRouteImport } from './routes/_authenticated/project/$projectId/_plans/index'
import { Route as AuthenticatedProjectProjectIdPinsViewTypeRouteRouteImport } from './routes/_authenticated/project/$projectId/pins/$viewType/route'
import { Route as AuthenticatedProjectProjectIdPlanIdViewerRouteRouteImport } from './routes/_authenticated/project/$projectId/$planId/_viewer/route'
import { Route as AuthenticatedUserManagementUserUserIdEditIndexRouteImport } from './routes/_authenticated/userManagement/user/$userId/edit/index'
import { Route as AuthenticatedProjectProjectsSettingsProjectIdIndexRouteImport } from './routes/_authenticated/project/_projects/settings/$projectId/index'
import { Route as AuthenticatedProjectProjectsInfoProjectIdIndexRouteImport } from './routes/_authenticated/project/_projects/info/$projectId/index'
import { Route as AuthenticatedProjectProjectIdTasksNewIndexRouteImport } from './routes/_authenticated/project/$projectId/tasks/new/index'
import { Route as AuthenticatedProjectProjectIdReportsNewReportIndexRouteImport } from './routes/_authenticated/project/$projectId/reports/newReport/index'
import { Route as AuthenticatedProjectProjectIdReportsReportIdIndexRouteImport } from './routes/_authenticated/project/$projectId/reports/$reportId/index'
import { Route as AuthenticatedProjectProjectIdDatasetsDatasetIdIndexRouteImport } from './routes/_authenticated/project/$projectId/datasets/$datasetId/index'
import { Route as AuthenticatedProjectProjectIdPlansUpgradeIndexRouteImport } from './routes/_authenticated/project/$projectId/_plans/upgrade/index'
import { Route as AuthenticatedProjectProjectIdPlansRenameIndexRouteImport } from './routes/_authenticated/project/$projectId/_plans/rename/index'
import { Route as AuthenticatedProjectProjectIdPlansNewfolderIndexRouteImport } from './routes/_authenticated/project/$projectId/_plans/newfolder/index'
import { Route as AuthenticatedProjectProjectIdPlansImportIndexRouteImport } from './routes/_authenticated/project/$projectId/_plans/import/index'
import { Route as AuthenticatedProjectProjectIdGroupsGroupIdViewTypeRouteRouteImport } from './routes/_authenticated/project/$projectId/groups/$groupId/$viewType/route'
import { Route as AuthenticatedProjectProjectsMoveProjectProjectIdIndexRouteImport } from './routes/_authenticated/project/_projects/move/project/$projectId/index'
import { Route as AuthenticatedProjectProjectsMoveFolderFolderIdIndexRouteImport } from './routes/_authenticated/project/_projects/move/folder/$folderId/index'
import { Route as AuthenticatedProjectProjectIdReportsShareReportIdIndexRouteImport } from './routes/_authenticated/project/$projectId/reports/share/$reportId/index'
import { Route as AuthenticatedProjectProjectIdPinsViewTypeNoPlanIndexRouteImport } from './routes/_authenticated/project/$projectId/pins/$viewType/noPlan/index'
import { Route as AuthenticatedProjectProjectIdPinsViewTypePlanIdIndexRouteImport } from './routes/_authenticated/project/$projectId/pins/$viewType/$planId/index'
import { Route as AuthenticatedProjectProjectIdGroupsGroupIdViewTypeIndexRouteImport } from './routes/_authenticated/project/$projectId/groups/$groupId/$viewType/index'
import { Route as AuthenticatedProjectProjectIdPlansPlanVersionsPlanIdIndexRouteImport } from './routes/_authenticated/project/$projectId/_plans/planVersions/$planId/index'
import { Route as AuthenticatedProjectProjectIdPlansImportRevisionPlanIdIndexRouteImport } from './routes/_authenticated/project/$projectId/_plans/importRevision/$planId/index'
import { Route as AuthenticatedProjectProjectIdPlansExportPlanPlanIdIndexRouteImport } from './routes/_authenticated/project/$projectId/_plans/exportPlan/$planId/index'
import { Route as AuthenticatedProjectProjectIdPlanIdViewerViewTypeIndexRouteImport } from './routes/_authenticated/project/$projectId/$planId/_viewer/$viewType/index'
import { Route as AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRouteImport } from './routes/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/route'
import { Route as AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRouteImport } from './routes/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/route'
import { Route as AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRouteImport } from './routes/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/route'
import { Route as AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdIndexRouteImport } from './routes/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/index'
import { Route as AuthenticatedProjectProjectIdPlansMovePlanItemIdIndexRouteImport } from './routes/_authenticated/project/$projectId/_plans/move/plan/$itemId/index'
import { Route as AuthenticatedProjectProjectIdPlansMoveFolderItemIdIndexRouteImport } from './routes/_authenticated/project/$projectId/_plans/move/folder/$itemId/index'
import { Route as AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRouteImport } from './routes/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/route'
import { Route as AuthenticatedProjectProjectIdMediaGalleryYearMonthFileIdIndexRouteImport } from './routes/_authenticated/project/$projectId/media/gallery/$year/$month/$fileId/index'
import { Route as AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskCreateTaskIndexRouteImport } from './routes/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/create-task/index'
import { Route as AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskCreateTaskIndexRouteImport } from './routes/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/create-task/index'
import { Route as AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskCreateTaskIndexRouteImport } from './routes/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/create-task/index'
import { Route as AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRouteImport } from './routes/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/route'
import { Route as AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteImport } from './routes/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/route'
import { Route as AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRouteImport } from './routes/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/task-details/$taskId/route'
import { Route as AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskCreateTaskSelectAssigneeIndexRouteImport } from './routes/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/create-task/select-assignee/index'
import { Route as AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdGalleryPostIdFileIdIndexRouteImport } from './routes/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/gallery/$postId/$fileId/index'
import { Route as AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskCreateTaskSelectAssigneeIndexRouteImport } from './routes/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/create-task/select-assignee/index'
import { Route as AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdGalleryPostIdFileIdIndexRouteImport } from './routes/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/gallery/$postId/$fileId/index'
import { Route as AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskCreateTaskIndexRouteImport } from './routes/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/create-task/index'
import { Route as AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskCreateTaskSelectAssigneeIndexRouteImport } from './routes/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/create-task/select-assignee/index'
import { Route as AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdGalleryPostIdFileIdIndexRouteImport } from './routes/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/gallery/$postId/$fileId/index'
import { Route as AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteImport } from './routes/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/route'
import { Route as AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRouteImport } from './routes/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/change-assignee/index'
import { Route as AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdAllVisualsGalleryPostIdFileIdIndexRouteImport } from './routes/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/allVisuals/gallery/$postId/$fileId/index'
import { Route as AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRouteImport } from './routes/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/change-assignee/index'
import { Route as AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdAllVisualsGalleryPostIdFileIdIndexRouteImport } from './routes/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/allVisuals/gallery/$postId/$fileId/index'
import { Route as AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskCreateTaskSelectAssigneeIndexRouteImport } from './routes/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/create-task/select-assignee/index'
import { Route as AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdGalleryPostIdFileIdIndexRouteImport } from './routes/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/gallery/$postId/$fileId/index'
import { Route as AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRouteImport } from './routes/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/task-details/$taskId/change-assignee/index'
import { Route as AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdAllVisualsGalleryPostIdFileIdIndexRouteImport } from './routes/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/allVisuals/gallery/$postId/$fileId/index'
import { Route as AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRouteImport } from './routes/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/edit-comment/$id/index'
import { Route as AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRouteImport } from './routes/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/edit-comment/$id/index'
import { Route as AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRouteImport } from './routes/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/change-assignee/index'
import { Route as AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdAllVisualsGalleryPostIdFileIdIndexRouteImport } from './routes/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/allVisuals/gallery/$postId/$fileId/index'
import { Route as AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdEditCommentIdIndexRouteImport } from './routes/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/task-details/$taskId/edit-comment/$id/index'
import { Route as AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRouteImport } from './routes/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/index'
import { Route as AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRouteImport } from './routes/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/index'
import { Route as AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRouteImport } from './routes/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/edit-comment/$id/index'
import { Route as AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRouteImport } from './routes/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/index'
import { Route as AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRouteImport } from './routes/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/index'

const UnauthenticatedRouteRoute = UnauthenticatedRouteRouteImport.update({
  id: '/_unauthenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSplatRoute = AuthenticatedSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedUserManagementRouteRoute =
  AuthenticatedUserManagementRouteRouteImport.update({
    id: '/userManagement',
    path: '/userManagement',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectRouteRoute =
  AuthenticatedProjectRouteRouteImport.update({
    id: '/project',
    path: '/project',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const HomeModeIndexRoute = HomeModeIndexRouteImport.update({
  id: '/home/$mode/',
  path: '/home/$mode/',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedSsoSelectionIndexRoute =
  UnauthenticatedSsoSelectionIndexRouteImport.update({
    id: '/ssoSelection/',
    path: '/ssoSelection/',
    getParentRoute: () => UnauthenticatedRouteRoute,
  } as any)
const UnauthenticatedSamlLoginIndexRoute =
  UnauthenticatedSamlLoginIndexRouteImport.update({
    id: '/samlLogin/',
    path: '/samlLogin/',
    getParentRoute: () => UnauthenticatedRouteRoute,
  } as any)
const UnauthenticatedRegisterIndexRoute =
  UnauthenticatedRegisterIndexRouteImport.update({
    id: '/register/',
    path: '/register/',
    getParentRoute: () => UnauthenticatedRouteRoute,
  } as any)
const UnauthenticatedLoginIndexRoute =
  UnauthenticatedLoginIndexRouteImport.update({
    id: '/login/',
    path: '/login/',
    getParentRoute: () => UnauthenticatedRouteRoute,
  } as any)
const UnauthenticatedIdpSelectionIndexRoute =
  UnauthenticatedIdpSelectionIndexRouteImport.update({
    id: '/idpSelection/',
    path: '/idpSelection/',
    getParentRoute: () => UnauthenticatedRouteRoute,
  } as any)
const AuthenticatedUserSettingsIndexRoute =
  AuthenticatedUserSettingsIndexRouteImport.update({
    id: '/userSettings/',
    path: '/userSettings/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUpgradeIndexRoute =
  AuthenticatedUpgradeIndexRouteImport.update({
    id: '/upgrade/',
    path: '/upgrade/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedReportTemplatesIndexRoute =
  AuthenticatedReportTemplatesIndexRouteImport.update({
    id: '/reportTemplates/',
    path: '/reportTemplates/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHomeIndexRoute = AuthenticatedHomeIndexRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedProjectProjectsRouteRoute =
  AuthenticatedProjectProjectsRouteRouteImport.update({
    id: '/_projects',
    getParentRoute: () => AuthenticatedProjectRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdRouteRoute =
  AuthenticatedProjectProjectIdRouteRouteImport.update({
    id: '/$projectId',
    path: '/$projectId',
    getParentRoute: () => AuthenticatedProjectRouteRoute,
  } as any)
const HomeModeTokenIndexRoute = HomeModeTokenIndexRouteImport.update({
  id: '/home/$mode/$token/',
  path: '/home/$mode/$token/',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedRegisterVerificationCodeIndexRoute =
  UnauthenticatedRegisterVerificationCodeIndexRouteImport.update({
    id: '/register/verification-code/',
    path: '/register/verification-code/',
    getParentRoute: () => UnauthenticatedRouteRoute,
  } as any)
const UnauthenticatedRegisterInvitedTokenIndexRoute =
  UnauthenticatedRegisterInvitedTokenIndexRouteImport.update({
    id: '/register/$invitedToken/',
    path: '/register/$invitedToken/',
    getParentRoute: () => UnauthenticatedRouteRoute,
  } as any)
const AuthenticatedUserManagementCompaniesIndexRoute =
  AuthenticatedUserManagementCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => AuthenticatedUserManagementRouteRoute,
  } as any)
const AuthenticatedProjectProjectsIndexRoute =
  AuthenticatedProjectProjectsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProjectProjectsRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdTasksRouteRoute =
  AuthenticatedProjectProjectIdTasksRouteRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => AuthenticatedProjectProjectIdRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdReportsRouteRoute =
  AuthenticatedProjectProjectIdReportsRouteRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AuthenticatedProjectProjectIdRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdMediaRouteRoute =
  AuthenticatedProjectProjectIdMediaRouteRouteImport.update({
    id: '/media',
    path: '/media',
    getParentRoute: () => AuthenticatedProjectProjectIdRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdDatasetsRouteRoute =
  AuthenticatedProjectProjectIdDatasetsRouteRouteImport.update({
    id: '/datasets',
    path: '/datasets',
    getParentRoute: () => AuthenticatedProjectProjectIdRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdPlansRouteRoute =
  AuthenticatedProjectProjectIdPlansRouteRouteImport.update({
    id: '/_plans',
    getParentRoute: () => AuthenticatedProjectProjectIdRouteRoute,
  } as any)
const UnauthenticatedActivateTypeTokenIndexRoute =
  UnauthenticatedActivateTypeTokenIndexRouteImport.update({
    id: '/activate/$type/$token/',
    path: '/activate/$type/$token/',
    getParentRoute: () => UnauthenticatedRouteRoute,
  } as any)
const AuthenticatedUserManagementFolderRestrictionUserIdIndexRoute =
  AuthenticatedUserManagementFolderRestrictionUserIdIndexRouteImport.update({
    id: '/folderRestriction/$userId/',
    path: '/folderRestriction/$userId/',
    getParentRoute: () => AuthenticatedUserManagementRouteRoute,
  } as any)
const AuthenticatedProjectProjectsRenameIndexRoute =
  AuthenticatedProjectProjectsRenameIndexRouteImport.update({
    id: '/rename/',
    path: '/rename/',
    getParentRoute: () => AuthenticatedProjectProjectsRouteRoute,
  } as any)
const AuthenticatedProjectProjectsNewfolderIndexRoute =
  AuthenticatedProjectProjectsNewfolderIndexRouteImport.update({
    id: '/newfolder/',
    path: '/newfolder/',
    getParentRoute: () => AuthenticatedProjectProjectsRouteRoute,
  } as any)
const AuthenticatedProjectProjectsNewIndexRoute =
  AuthenticatedProjectProjectsNewIndexRouteImport.update({
    id: '/new/',
    path: '/new/',
    getParentRoute: () => AuthenticatedProjectProjectsRouteRoute,
  } as any)
const AuthenticatedProjectProjectsCopyIndexRoute =
  AuthenticatedProjectProjectsCopyIndexRouteImport.update({
    id: '/copy/',
    path: '/copy/',
    getParentRoute: () => AuthenticatedProjectProjectsRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdTeamIndexRoute =
  AuthenticatedProjectProjectIdTeamIndexRouteImport.update({
    id: '/team/',
    path: '/team/',
    getParentRoute: () => AuthenticatedProjectProjectIdRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdTasksIndexRoute =
  AuthenticatedProjectProjectIdTasksIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProjectProjectIdTasksRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdMediaIndexRoute =
  AuthenticatedProjectProjectIdMediaIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProjectProjectIdMediaRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdGroupsIndexRoute =
  AuthenticatedProjectProjectIdGroupsIndexRouteImport.update({
    id: '/groups/',
    path: '/groups/',
    getParentRoute: () => AuthenticatedProjectProjectIdRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdDatasetsIndexRoute =
  AuthenticatedProjectProjectIdDatasetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProjectProjectIdDatasetsRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdPlansIndexRoute =
  AuthenticatedProjectProjectIdPlansIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProjectProjectIdPlansRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdPinsViewTypeRouteRoute =
  AuthenticatedProjectProjectIdPinsViewTypeRouteRouteImport.update({
    id: '/pins/$viewType',
    path: '/pins/$viewType',
    getParentRoute: () => AuthenticatedProjectProjectIdRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdPlanIdViewerRouteRoute =
  AuthenticatedProjectProjectIdPlanIdViewerRouteRouteImport.update({
    id: '/$planId/_viewer',
    path: '/$planId',
    getParentRoute: () => AuthenticatedProjectProjectIdRouteRoute,
  } as any)
const AuthenticatedUserManagementUserUserIdEditIndexRoute =
  AuthenticatedUserManagementUserUserIdEditIndexRouteImport.update({
    id: '/user/$userId/edit/',
    path: '/user/$userId/edit/',
    getParentRoute: () => AuthenticatedUserManagementRouteRoute,
  } as any)
const AuthenticatedProjectProjectsSettingsProjectIdIndexRoute =
  AuthenticatedProjectProjectsSettingsProjectIdIndexRouteImport.update({
    id: '/settings/$projectId/',
    path: '/settings/$projectId/',
    getParentRoute: () => AuthenticatedProjectProjectsRouteRoute,
  } as any)
const AuthenticatedProjectProjectsInfoProjectIdIndexRoute =
  AuthenticatedProjectProjectsInfoProjectIdIndexRouteImport.update({
    id: '/info/$projectId/',
    path: '/info/$projectId/',
    getParentRoute: () => AuthenticatedProjectProjectsRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdTasksNewIndexRoute =
  AuthenticatedProjectProjectIdTasksNewIndexRouteImport.update({
    id: '/new/',
    path: '/new/',
    getParentRoute: () => AuthenticatedProjectProjectIdTasksRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdReportsNewReportIndexRoute =
  AuthenticatedProjectProjectIdReportsNewReportIndexRouteImport.update({
    id: '/newReport/',
    path: '/newReport/',
    getParentRoute: () => AuthenticatedProjectProjectIdReportsRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdReportsReportIdIndexRoute =
  AuthenticatedProjectProjectIdReportsReportIdIndexRouteImport.update({
    id: '/$reportId/',
    path: '/$reportId/',
    getParentRoute: () => AuthenticatedProjectProjectIdReportsRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdDatasetsDatasetIdIndexRoute =
  AuthenticatedProjectProjectIdDatasetsDatasetIdIndexRouteImport.update({
    id: '/$datasetId/',
    path: '/$datasetId/',
    getParentRoute: () => AuthenticatedProjectProjectIdDatasetsRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdPlansUpgradeIndexRoute =
  AuthenticatedProjectProjectIdPlansUpgradeIndexRouteImport.update({
    id: '/upgrade/',
    path: '/upgrade/',
    getParentRoute: () => AuthenticatedProjectProjectIdPlansRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdPlansRenameIndexRoute =
  AuthenticatedProjectProjectIdPlansRenameIndexRouteImport.update({
    id: '/rename/',
    path: '/rename/',
    getParentRoute: () => AuthenticatedProjectProjectIdPlansRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdPlansNewfolderIndexRoute =
  AuthenticatedProjectProjectIdPlansNewfolderIndexRouteImport.update({
    id: '/newfolder/',
    path: '/newfolder/',
    getParentRoute: () => AuthenticatedProjectProjectIdPlansRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdPlansImportIndexRoute =
  AuthenticatedProjectProjectIdPlansImportIndexRouteImport.update({
    id: '/import/',
    path: '/import/',
    getParentRoute: () => AuthenticatedProjectProjectIdPlansRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdGroupsGroupIdViewTypeRouteRoute =
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypeRouteRouteImport.update({
    id: '/groups/$groupId/$viewType',
    path: '/groups/$groupId/$viewType',
    getParentRoute: () => AuthenticatedProjectProjectIdRouteRoute,
  } as any)
const AuthenticatedProjectProjectsMoveProjectProjectIdIndexRoute =
  AuthenticatedProjectProjectsMoveProjectProjectIdIndexRouteImport.update({
    id: '/move/project/$projectId/',
    path: '/move/project/$projectId/',
    getParentRoute: () => AuthenticatedProjectProjectsRouteRoute,
  } as any)
const AuthenticatedProjectProjectsMoveFolderFolderIdIndexRoute =
  AuthenticatedProjectProjectsMoveFolderFolderIdIndexRouteImport.update({
    id: '/move/folder/$folderId/',
    path: '/move/folder/$folderId/',
    getParentRoute: () => AuthenticatedProjectProjectsRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdReportsShareReportIdIndexRoute =
  AuthenticatedProjectProjectIdReportsShareReportIdIndexRouteImport.update({
    id: '/share/$reportId/',
    path: '/share/$reportId/',
    getParentRoute: () => AuthenticatedProjectProjectIdReportsRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdPinsViewTypeNoPlanIndexRoute =
  AuthenticatedProjectProjectIdPinsViewTypeNoPlanIndexRouteImport.update({
    id: '/noPlan/',
    path: '/noPlan/',
    getParentRoute: () => AuthenticatedProjectProjectIdPinsViewTypeRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdPinsViewTypePlanIdIndexRoute =
  AuthenticatedProjectProjectIdPinsViewTypePlanIdIndexRouteImport.update({
    id: '/$planId/',
    path: '/$planId/',
    getParentRoute: () => AuthenticatedProjectProjectIdPinsViewTypeRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdGroupsGroupIdViewTypeIndexRoute =
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedProjectProjectIdGroupsGroupIdViewTypeRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdPlansPlanVersionsPlanIdIndexRoute =
  AuthenticatedProjectProjectIdPlansPlanVersionsPlanIdIndexRouteImport.update({
    id: '/planVersions/$planId/',
    path: '/planVersions/$planId/',
    getParentRoute: () => AuthenticatedProjectProjectIdPlansRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdPlansImportRevisionPlanIdIndexRoute =
  AuthenticatedProjectProjectIdPlansImportRevisionPlanIdIndexRouteImport.update(
    {
      id: '/importRevision/$planId/',
      path: '/importRevision/$planId/',
      getParentRoute: () => AuthenticatedProjectProjectIdPlansRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPlansExportPlanPlanIdIndexRoute =
  AuthenticatedProjectProjectIdPlansExportPlanPlanIdIndexRouteImport.update({
    id: '/exportPlan/$planId/',
    path: '/exportPlan/$planId/',
    getParentRoute: () => AuthenticatedProjectProjectIdPlansRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdPlanIdViewerViewTypeIndexRoute =
  AuthenticatedProjectProjectIdPlanIdViewerViewTypeIndexRouteImport.update({
    id: '/$viewType/',
    path: '/$viewType/',
    getParentRoute: () => AuthenticatedProjectProjectIdPlanIdViewerRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRoute =
  AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRouteImport.update({
    id: '/noPlan/$pinId',
    path: '/noPlan/$pinId',
    getParentRoute: () => AuthenticatedProjectProjectIdPinsViewTypeRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRoute =
  AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRouteImport.update({
    id: '/$planId/$pinId',
    path: '/$planId/$pinId',
    getParentRoute: () => AuthenticatedProjectProjectIdPinsViewTypeRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRoute =
  AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRouteImport.update(
    {
      id: '/$viewType/$pinId',
      path: '/$viewType/$pinId',
      getParentRoute: () => AuthenticatedProjectProjectIdPlanIdViewerRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdIndexRoute =
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdIndexRouteImport.update(
    {
      id: '/$planId/',
      path: '/$planId/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdGroupsGroupIdViewTypeRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPlansMovePlanItemIdIndexRoute =
  AuthenticatedProjectProjectIdPlansMovePlanItemIdIndexRouteImport.update({
    id: '/move/plan/$itemId/',
    path: '/move/plan/$itemId/',
    getParentRoute: () => AuthenticatedProjectProjectIdPlansRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdPlansMoveFolderItemIdIndexRoute =
  AuthenticatedProjectProjectIdPlansMoveFolderItemIdIndexRouteImport.update({
    id: '/move/folder/$itemId/',
    path: '/move/folder/$itemId/',
    getParentRoute: () => AuthenticatedProjectProjectIdPlansRouteRoute,
  } as any)
const AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRoute =
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRouteImport.update(
    {
      id: '/$planId/$pinId',
      path: '/$planId/$pinId',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdGroupsGroupIdViewTypeRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdMediaGalleryYearMonthFileIdIndexRoute =
  AuthenticatedProjectProjectIdMediaGalleryYearMonthFileIdIndexRouteImport.update(
    {
      id: '/gallery/$year/$month/$fileId/',
      path: '/gallery/$year/$month/$fileId/',
      getParentRoute: () => AuthenticatedProjectProjectIdMediaRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskCreateTaskIndexRoute =
  AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskCreateTaskIndexRouteImport.update(
    {
      id: '/task/create-task/',
      path: '/task/create-task/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskCreateTaskIndexRoute =
  AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskCreateTaskIndexRouteImport.update(
    {
      id: '/task/create-task/',
      path: '/task/create-task/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskCreateTaskIndexRoute =
  AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskCreateTaskIndexRouteImport.update(
    {
      id: '/task/create-task/',
      path: '/task/create-task/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRoute =
  AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRouteImport.update(
    {
      id: '/task/task-details/$taskId',
      path: '/task/task-details/$taskId',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRoute =
  AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteImport.update(
    {
      id: '/task/task-details/$taskId',
      path: '/task/task-details/$taskId',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRoute =
  AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRouteImport.update(
    {
      id: '/task/task-details/$taskId',
      path: '/task/task-details/$taskId',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskCreateTaskSelectAssigneeIndexRoute =
  AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskCreateTaskSelectAssigneeIndexRouteImport.update(
    {
      id: '/task/create-task/select-assignee/',
      path: '/task/create-task/select-assignee/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdGalleryPostIdFileIdIndexRoute =
  AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdGalleryPostIdFileIdIndexRouteImport.update(
    {
      id: '/gallery/$postId/$fileId/',
      path: '/gallery/$postId/$fileId/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskCreateTaskSelectAssigneeIndexRoute =
  AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskCreateTaskSelectAssigneeIndexRouteImport.update(
    {
      id: '/task/create-task/select-assignee/',
      path: '/task/create-task/select-assignee/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdGalleryPostIdFileIdIndexRoute =
  AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdGalleryPostIdFileIdIndexRouteImport.update(
    {
      id: '/gallery/$postId/$fileId/',
      path: '/gallery/$postId/$fileId/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskCreateTaskIndexRoute =
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskCreateTaskIndexRouteImport.update(
    {
      id: '/task/create-task/',
      path: '/task/create-task/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskCreateTaskSelectAssigneeIndexRoute =
  AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskCreateTaskSelectAssigneeIndexRouteImport.update(
    {
      id: '/task/create-task/select-assignee/',
      path: '/task/create-task/select-assignee/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdGalleryPostIdFileIdIndexRoute =
  AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdGalleryPostIdFileIdIndexRouteImport.update(
    {
      id: '/gallery/$postId/$fileId/',
      path: '/gallery/$postId/$fileId/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRoute =
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteImport.update(
    {
      id: '/task/task-details/$taskId',
      path: '/task/task-details/$taskId',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute =
  AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRouteImport.update(
    {
      id: '/change-assignee/',
      path: '/change-assignee/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdAllVisualsGalleryPostIdFileIdIndexRoute =
  AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdAllVisualsGalleryPostIdFileIdIndexRouteImport.update(
    {
      id: '/allVisuals/gallery/$postId/$fileId/',
      path: '/allVisuals/gallery/$postId/$fileId/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute =
  AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRouteImport.update(
    {
      id: '/change-assignee/',
      path: '/change-assignee/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdAllVisualsGalleryPostIdFileIdIndexRoute =
  AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdAllVisualsGalleryPostIdFileIdIndexRouteImport.update(
    {
      id: '/allVisuals/gallery/$postId/$fileId/',
      path: '/allVisuals/gallery/$postId/$fileId/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskCreateTaskSelectAssigneeIndexRoute =
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskCreateTaskSelectAssigneeIndexRouteImport.update(
    {
      id: '/task/create-task/select-assignee/',
      path: '/task/create-task/select-assignee/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdGalleryPostIdFileIdIndexRoute =
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdGalleryPostIdFileIdIndexRouteImport.update(
    {
      id: '/gallery/$postId/$fileId/',
      path: '/gallery/$postId/$fileId/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute =
  AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRouteImport.update(
    {
      id: '/change-assignee/',
      path: '/change-assignee/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdAllVisualsGalleryPostIdFileIdIndexRoute =
  AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdAllVisualsGalleryPostIdFileIdIndexRouteImport.update(
    {
      id: '/allVisuals/gallery/$postId/$fileId/',
      path: '/allVisuals/gallery/$postId/$fileId/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute =
  AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRouteImport.update(
    {
      id: '/edit-comment/$id/',
      path: '/edit-comment/$id/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute =
  AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRouteImport.update(
    {
      id: '/edit-comment/$id/',
      path: '/edit-comment/$id/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute =
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRouteImport.update(
    {
      id: '/change-assignee/',
      path: '/change-assignee/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdAllVisualsGalleryPostIdFileIdIndexRoute =
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdAllVisualsGalleryPostIdFileIdIndexRouteImport.update(
    {
      id: '/allVisuals/gallery/$postId/$fileId/',
      path: '/allVisuals/gallery/$postId/$fileId/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute =
  AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdEditCommentIdIndexRouteImport.update(
    {
      id: '/edit-comment/$id/',
      path: '/edit-comment/$id/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute =
  AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRouteImport.update(
    {
      id: '/comment-gallery/$fileId/$commentId/',
      path: '/comment-gallery/$fileId/$commentId/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute =
  AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRouteImport.update(
    {
      id: '/comment-gallery/$fileId/$commentId/',
      path: '/comment-gallery/$fileId/$commentId/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute =
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRouteImport.update(
    {
      id: '/edit-comment/$id/',
      path: '/edit-comment/$id/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute =
  AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRouteImport.update(
    {
      id: '/comment-gallery/$fileId/$commentId/',
      path: '/comment-gallery/$fileId/$commentId/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute =
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRouteImport.update(
    {
      id: '/comment-gallery/$fileId/$commentId/',
      path: '/comment-gallery/$fileId/$commentId/',
      getParentRoute: () =>
        AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/project': typeof AuthenticatedProjectProjectsRouteRouteWithChildren
  '/userManagement': typeof AuthenticatedUserManagementRouteRouteWithChildren
  '/$': typeof AuthenticatedSplatRoute
  '/project/$projectId': typeof AuthenticatedProjectProjectIdPlansRouteRouteWithChildren
  '/home/': typeof AuthenticatedHomeIndexRoute
  '/reportTemplates/': typeof AuthenticatedReportTemplatesIndexRoute
  '/upgrade/': typeof AuthenticatedUpgradeIndexRoute
  '/userSettings/': typeof AuthenticatedUserSettingsIndexRoute
  '/idpSelection/': typeof UnauthenticatedIdpSelectionIndexRoute
  '/login/': typeof UnauthenticatedLoginIndexRoute
  '/register/': typeof UnauthenticatedRegisterIndexRoute
  '/samlLogin/': typeof UnauthenticatedSamlLoginIndexRoute
  '/ssoSelection/': typeof UnauthenticatedSsoSelectionIndexRoute
  '/home/$mode/': typeof HomeModeIndexRoute
  '/project/$projectId/datasets': typeof AuthenticatedProjectProjectIdDatasetsRouteRouteWithChildren
  '/project/$projectId/media': typeof AuthenticatedProjectProjectIdMediaRouteRouteWithChildren
  '/project/$projectId/reports': typeof AuthenticatedProjectProjectIdReportsRouteRouteWithChildren
  '/project/$projectId/tasks': typeof AuthenticatedProjectProjectIdTasksRouteRouteWithChildren
  '/project/': typeof AuthenticatedProjectProjectsIndexRoute
  '/userManagement/companies/': typeof AuthenticatedUserManagementCompaniesIndexRoute
  '/register/$invitedToken/': typeof UnauthenticatedRegisterInvitedTokenIndexRoute
  '/register/verification-code/': typeof UnauthenticatedRegisterVerificationCodeIndexRoute
  '/home/$mode/$token/': typeof HomeModeTokenIndexRoute
  '/project/$projectId/$planId': typeof AuthenticatedProjectProjectIdPlanIdViewerRouteRouteWithChildren
  '/project/$projectId/pins/$viewType': typeof AuthenticatedProjectProjectIdPinsViewTypeRouteRouteWithChildren
  '/project/$projectId/': typeof AuthenticatedProjectProjectIdPlansIndexRoute
  '/project/$projectId/datasets/': typeof AuthenticatedProjectProjectIdDatasetsIndexRoute
  '/project/$projectId/groups/': typeof AuthenticatedProjectProjectIdGroupsIndexRoute
  '/project/$projectId/media/': typeof AuthenticatedProjectProjectIdMediaIndexRoute
  '/project/$projectId/tasks/': typeof AuthenticatedProjectProjectIdTasksIndexRoute
  '/project/$projectId/team/': typeof AuthenticatedProjectProjectIdTeamIndexRoute
  '/project/copy/': typeof AuthenticatedProjectProjectsCopyIndexRoute
  '/project/new/': typeof AuthenticatedProjectProjectsNewIndexRoute
  '/project/newfolder/': typeof AuthenticatedProjectProjectsNewfolderIndexRoute
  '/project/rename/': typeof AuthenticatedProjectProjectsRenameIndexRoute
  '/userManagement/folderRestriction/$userId/': typeof AuthenticatedUserManagementFolderRestrictionUserIdIndexRoute
  '/activate/$type/$token/': typeof UnauthenticatedActivateTypeTokenIndexRoute
  '/project/$projectId/groups/$groupId/$viewType': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypeRouteRouteWithChildren
  '/project/$projectId/import/': typeof AuthenticatedProjectProjectIdPlansImportIndexRoute
  '/project/$projectId/newfolder/': typeof AuthenticatedProjectProjectIdPlansNewfolderIndexRoute
  '/project/$projectId/rename/': typeof AuthenticatedProjectProjectIdPlansRenameIndexRoute
  '/project/$projectId/upgrade/': typeof AuthenticatedProjectProjectIdPlansUpgradeIndexRoute
  '/project/$projectId/datasets/$datasetId/': typeof AuthenticatedProjectProjectIdDatasetsDatasetIdIndexRoute
  '/project/$projectId/reports/$reportId/': typeof AuthenticatedProjectProjectIdReportsReportIdIndexRoute
  '/project/$projectId/reports/newReport/': typeof AuthenticatedProjectProjectIdReportsNewReportIndexRoute
  '/project/$projectId/tasks/new/': typeof AuthenticatedProjectProjectIdTasksNewIndexRoute
  '/project/info/$projectId/': typeof AuthenticatedProjectProjectsInfoProjectIdIndexRoute
  '/project/settings/$projectId/': typeof AuthenticatedProjectProjectsSettingsProjectIdIndexRoute
  '/userManagement/user/$userId/edit/': typeof AuthenticatedUserManagementUserUserIdEditIndexRoute
  '/project/$projectId/$planId/$viewType/$pinId': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRouteWithChildren
  '/project/$projectId/pins/$viewType/$planId/$pinId': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRouteWithChildren
  '/project/$projectId/pins/$viewType/noPlan/$pinId': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRouteWithChildren
  '/project/$projectId/$planId/$viewType/': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypeIndexRoute
  '/project/$projectId/exportPlan/$planId/': typeof AuthenticatedProjectProjectIdPlansExportPlanPlanIdIndexRoute
  '/project/$projectId/importRevision/$planId/': typeof AuthenticatedProjectProjectIdPlansImportRevisionPlanIdIndexRoute
  '/project/$projectId/planVersions/$planId/': typeof AuthenticatedProjectProjectIdPlansPlanVersionsPlanIdIndexRoute
  '/project/$projectId/groups/$groupId/$viewType/': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypeIndexRoute
  '/project/$projectId/pins/$viewType/$planId/': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdIndexRoute
  '/project/$projectId/pins/$viewType/noPlan/': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanIndexRoute
  '/project/$projectId/reports/share/$reportId/': typeof AuthenticatedProjectProjectIdReportsShareReportIdIndexRoute
  '/project/move/folder/$folderId/': typeof AuthenticatedProjectProjectsMoveFolderFolderIdIndexRoute
  '/project/move/project/$projectId/': typeof AuthenticatedProjectProjectsMoveProjectProjectIdIndexRoute
  '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRouteWithChildren
  '/project/$projectId/move/folder/$itemId/': typeof AuthenticatedProjectProjectIdPlansMoveFolderItemIdIndexRoute
  '/project/$projectId/move/plan/$itemId/': typeof AuthenticatedProjectProjectIdPlansMovePlanItemIdIndexRoute
  '/project/$projectId/groups/$groupId/$viewType/$planId/': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdIndexRoute
  '/project/$projectId/media/gallery/$year/$month/$fileId/': typeof AuthenticatedProjectProjectIdMediaGalleryYearMonthFileIdIndexRoute
  '/project/$projectId/$planId/$viewType/$pinId/task/task-details/$taskId': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRouteWithChildren
  '/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteWithChildren
  '/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRouteWithChildren
  '/project/$projectId/$planId/$viewType/$pinId/task/create-task/': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskCreateTaskIndexRoute
  '/project/$projectId/pins/$viewType/$planId/$pinId/task/create-task/': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskCreateTaskIndexRoute
  '/project/$projectId/pins/$viewType/noPlan/$pinId/task/create-task/': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskCreateTaskIndexRoute
  '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteWithChildren
  '/project/$projectId/$planId/$viewType/$pinId/gallery/$postId/$fileId/': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdGalleryPostIdFileIdIndexRoute
  '/project/$projectId/$planId/$viewType/$pinId/task/create-task/select-assignee/': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskCreateTaskSelectAssigneeIndexRoute
  '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/create-task/': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskCreateTaskIndexRoute
  '/project/$projectId/pins/$viewType/$planId/$pinId/gallery/$postId/$fileId/': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdGalleryPostIdFileIdIndexRoute
  '/project/$projectId/pins/$viewType/$planId/$pinId/task/create-task/select-assignee/': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskCreateTaskSelectAssigneeIndexRoute
  '/project/$projectId/pins/$viewType/noPlan/$pinId/gallery/$postId/$fileId/': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdGalleryPostIdFileIdIndexRoute
  '/project/$projectId/pins/$viewType/noPlan/$pinId/task/create-task/select-assignee/': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskCreateTaskSelectAssigneeIndexRoute
  '/project/$projectId/$planId/$viewType/$pinId/allVisuals/gallery/$postId/$fileId/': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdAllVisualsGalleryPostIdFileIdIndexRoute
  '/project/$projectId/$planId/$viewType/$pinId/task/task-details/$taskId/change-assignee/': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute
  '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/gallery/$postId/$fileId/': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdGalleryPostIdFileIdIndexRoute
  '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/create-task/select-assignee/': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskCreateTaskSelectAssigneeIndexRoute
  '/project/$projectId/pins/$viewType/$planId/$pinId/allVisuals/gallery/$postId/$fileId/': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdAllVisualsGalleryPostIdFileIdIndexRoute
  '/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/change-assignee/': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute
  '/project/$projectId/pins/$viewType/noPlan/$pinId/allVisuals/gallery/$postId/$fileId/': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdAllVisualsGalleryPostIdFileIdIndexRoute
  '/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/change-assignee/': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute
  '/project/$projectId/$planId/$viewType/$pinId/task/task-details/$taskId/edit-comment/$id/': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute
  '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/allVisuals/gallery/$postId/$fileId/': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdAllVisualsGalleryPostIdFileIdIndexRoute
  '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/change-assignee/': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute
  '/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/edit-comment/$id/': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute
  '/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/edit-comment/$id/': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute
  '/project/$projectId/$planId/$viewType/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute
  '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/edit-comment/$id/': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute
  '/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute
  '/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute
  '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/project': typeof AuthenticatedProjectProjectsIndexRoute
  '/userManagement': typeof AuthenticatedUserManagementRouteRouteWithChildren
  '/$': typeof AuthenticatedSplatRoute
  '/project/$projectId': typeof AuthenticatedProjectProjectIdPlansIndexRoute
  '/home': typeof AuthenticatedHomeIndexRoute
  '/reportTemplates': typeof AuthenticatedReportTemplatesIndexRoute
  '/upgrade': typeof AuthenticatedUpgradeIndexRoute
  '/userSettings': typeof AuthenticatedUserSettingsIndexRoute
  '/idpSelection': typeof UnauthenticatedIdpSelectionIndexRoute
  '/login': typeof UnauthenticatedLoginIndexRoute
  '/register': typeof UnauthenticatedRegisterIndexRoute
  '/samlLogin': typeof UnauthenticatedSamlLoginIndexRoute
  '/ssoSelection': typeof UnauthenticatedSsoSelectionIndexRoute
  '/home/$mode': typeof HomeModeIndexRoute
  '/project/$projectId/reports': typeof AuthenticatedProjectProjectIdReportsRouteRouteWithChildren
  '/userManagement/companies': typeof AuthenticatedUserManagementCompaniesIndexRoute
  '/register/$invitedToken': typeof UnauthenticatedRegisterInvitedTokenIndexRoute
  '/register/verification-code': typeof UnauthenticatedRegisterVerificationCodeIndexRoute
  '/home/$mode/$token': typeof HomeModeTokenIndexRoute
  '/project/$projectId/$planId': typeof AuthenticatedProjectProjectIdPlanIdViewerRouteRouteWithChildren
  '/project/$projectId/pins/$viewType': typeof AuthenticatedProjectProjectIdPinsViewTypeRouteRouteWithChildren
  '/project/$projectId/datasets': typeof AuthenticatedProjectProjectIdDatasetsIndexRoute
  '/project/$projectId/groups': typeof AuthenticatedProjectProjectIdGroupsIndexRoute
  '/project/$projectId/media': typeof AuthenticatedProjectProjectIdMediaIndexRoute
  '/project/$projectId/tasks': typeof AuthenticatedProjectProjectIdTasksIndexRoute
  '/project/$projectId/team': typeof AuthenticatedProjectProjectIdTeamIndexRoute
  '/project/copy': typeof AuthenticatedProjectProjectsCopyIndexRoute
  '/project/new': typeof AuthenticatedProjectProjectsNewIndexRoute
  '/project/newfolder': typeof AuthenticatedProjectProjectsNewfolderIndexRoute
  '/project/rename': typeof AuthenticatedProjectProjectsRenameIndexRoute
  '/userManagement/folderRestriction/$userId': typeof AuthenticatedUserManagementFolderRestrictionUserIdIndexRoute
  '/activate/$type/$token': typeof UnauthenticatedActivateTypeTokenIndexRoute
  '/project/$projectId/import': typeof AuthenticatedProjectProjectIdPlansImportIndexRoute
  '/project/$projectId/newfolder': typeof AuthenticatedProjectProjectIdPlansNewfolderIndexRoute
  '/project/$projectId/rename': typeof AuthenticatedProjectProjectIdPlansRenameIndexRoute
  '/project/$projectId/upgrade': typeof AuthenticatedProjectProjectIdPlansUpgradeIndexRoute
  '/project/$projectId/datasets/$datasetId': typeof AuthenticatedProjectProjectIdDatasetsDatasetIdIndexRoute
  '/project/$projectId/reports/$reportId': typeof AuthenticatedProjectProjectIdReportsReportIdIndexRoute
  '/project/$projectId/reports/newReport': typeof AuthenticatedProjectProjectIdReportsNewReportIndexRoute
  '/project/$projectId/tasks/new': typeof AuthenticatedProjectProjectIdTasksNewIndexRoute
  '/project/info/$projectId': typeof AuthenticatedProjectProjectsInfoProjectIdIndexRoute
  '/project/settings/$projectId': typeof AuthenticatedProjectProjectsSettingsProjectIdIndexRoute
  '/userManagement/user/$userId/edit': typeof AuthenticatedUserManagementUserUserIdEditIndexRoute
  '/project/$projectId/$planId/$viewType/$pinId': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRouteWithChildren
  '/project/$projectId/pins/$viewType/$planId/$pinId': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRouteWithChildren
  '/project/$projectId/pins/$viewType/noPlan/$pinId': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRouteWithChildren
  '/project/$projectId/$planId/$viewType': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypeIndexRoute
  '/project/$projectId/exportPlan/$planId': typeof AuthenticatedProjectProjectIdPlansExportPlanPlanIdIndexRoute
  '/project/$projectId/importRevision/$planId': typeof AuthenticatedProjectProjectIdPlansImportRevisionPlanIdIndexRoute
  '/project/$projectId/planVersions/$planId': typeof AuthenticatedProjectProjectIdPlansPlanVersionsPlanIdIndexRoute
  '/project/$projectId/groups/$groupId/$viewType': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypeIndexRoute
  '/project/$projectId/pins/$viewType/$planId': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdIndexRoute
  '/project/$projectId/pins/$viewType/noPlan': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanIndexRoute
  '/project/$projectId/reports/share/$reportId': typeof AuthenticatedProjectProjectIdReportsShareReportIdIndexRoute
  '/project/move/folder/$folderId': typeof AuthenticatedProjectProjectsMoveFolderFolderIdIndexRoute
  '/project/move/project/$projectId': typeof AuthenticatedProjectProjectsMoveProjectProjectIdIndexRoute
  '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRouteWithChildren
  '/project/$projectId/move/folder/$itemId': typeof AuthenticatedProjectProjectIdPlansMoveFolderItemIdIndexRoute
  '/project/$projectId/move/plan/$itemId': typeof AuthenticatedProjectProjectIdPlansMovePlanItemIdIndexRoute
  '/project/$projectId/groups/$groupId/$viewType/$planId': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdIndexRoute
  '/project/$projectId/media/gallery/$year/$month/$fileId': typeof AuthenticatedProjectProjectIdMediaGalleryYearMonthFileIdIndexRoute
  '/project/$projectId/$planId/$viewType/$pinId/task/task-details/$taskId': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRouteWithChildren
  '/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteWithChildren
  '/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRouteWithChildren
  '/project/$projectId/$planId/$viewType/$pinId/task/create-task': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskCreateTaskIndexRoute
  '/project/$projectId/pins/$viewType/$planId/$pinId/task/create-task': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskCreateTaskIndexRoute
  '/project/$projectId/pins/$viewType/noPlan/$pinId/task/create-task': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskCreateTaskIndexRoute
  '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteWithChildren
  '/project/$projectId/$planId/$viewType/$pinId/gallery/$postId/$fileId': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdGalleryPostIdFileIdIndexRoute
  '/project/$projectId/$planId/$viewType/$pinId/task/create-task/select-assignee': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskCreateTaskSelectAssigneeIndexRoute
  '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/create-task': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskCreateTaskIndexRoute
  '/project/$projectId/pins/$viewType/$planId/$pinId/gallery/$postId/$fileId': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdGalleryPostIdFileIdIndexRoute
  '/project/$projectId/pins/$viewType/$planId/$pinId/task/create-task/select-assignee': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskCreateTaskSelectAssigneeIndexRoute
  '/project/$projectId/pins/$viewType/noPlan/$pinId/gallery/$postId/$fileId': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdGalleryPostIdFileIdIndexRoute
  '/project/$projectId/pins/$viewType/noPlan/$pinId/task/create-task/select-assignee': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskCreateTaskSelectAssigneeIndexRoute
  '/project/$projectId/$planId/$viewType/$pinId/allVisuals/gallery/$postId/$fileId': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdAllVisualsGalleryPostIdFileIdIndexRoute
  '/project/$projectId/$planId/$viewType/$pinId/task/task-details/$taskId/change-assignee': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute
  '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/gallery/$postId/$fileId': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdGalleryPostIdFileIdIndexRoute
  '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/create-task/select-assignee': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskCreateTaskSelectAssigneeIndexRoute
  '/project/$projectId/pins/$viewType/$planId/$pinId/allVisuals/gallery/$postId/$fileId': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdAllVisualsGalleryPostIdFileIdIndexRoute
  '/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/change-assignee': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute
  '/project/$projectId/pins/$viewType/noPlan/$pinId/allVisuals/gallery/$postId/$fileId': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdAllVisualsGalleryPostIdFileIdIndexRoute
  '/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/change-assignee': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute
  '/project/$projectId/$planId/$viewType/$pinId/task/task-details/$taskId/edit-comment/$id': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute
  '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/allVisuals/gallery/$postId/$fileId': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdAllVisualsGalleryPostIdFileIdIndexRoute
  '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/change-assignee': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute
  '/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/edit-comment/$id': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute
  '/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/edit-comment/$id': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute
  '/project/$projectId/$planId/$viewType/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute
  '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/edit-comment/$id': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute
  '/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute
  '/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute
  '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_unauthenticated': typeof UnauthenticatedRouteRouteWithChildren
  '/_authenticated/project': typeof AuthenticatedProjectRouteRouteWithChildren
  '/_authenticated/userManagement': typeof AuthenticatedUserManagementRouteRouteWithChildren
  '/_authenticated/$': typeof AuthenticatedSplatRoute
  '/_authenticated/project/$projectId': typeof AuthenticatedProjectProjectIdRouteRouteWithChildren
  '/_authenticated/project/_projects': typeof AuthenticatedProjectProjectsRouteRouteWithChildren
  '/_authenticated/home/': typeof AuthenticatedHomeIndexRoute
  '/_authenticated/reportTemplates/': typeof AuthenticatedReportTemplatesIndexRoute
  '/_authenticated/upgrade/': typeof AuthenticatedUpgradeIndexRoute
  '/_authenticated/userSettings/': typeof AuthenticatedUserSettingsIndexRoute
  '/_unauthenticated/idpSelection/': typeof UnauthenticatedIdpSelectionIndexRoute
  '/_unauthenticated/login/': typeof UnauthenticatedLoginIndexRoute
  '/_unauthenticated/register/': typeof UnauthenticatedRegisterIndexRoute
  '/_unauthenticated/samlLogin/': typeof UnauthenticatedSamlLoginIndexRoute
  '/_unauthenticated/ssoSelection/': typeof UnauthenticatedSsoSelectionIndexRoute
  '/home/$mode/': typeof HomeModeIndexRoute
  '/_authenticated/project/$projectId/_plans': typeof AuthenticatedProjectProjectIdPlansRouteRouteWithChildren
  '/_authenticated/project/$projectId/datasets': typeof AuthenticatedProjectProjectIdDatasetsRouteRouteWithChildren
  '/_authenticated/project/$projectId/media': typeof AuthenticatedProjectProjectIdMediaRouteRouteWithChildren
  '/_authenticated/project/$projectId/reports': typeof AuthenticatedProjectProjectIdReportsRouteRouteWithChildren
  '/_authenticated/project/$projectId/tasks': typeof AuthenticatedProjectProjectIdTasksRouteRouteWithChildren
  '/_authenticated/project/_projects/': typeof AuthenticatedProjectProjectsIndexRoute
  '/_authenticated/userManagement/companies/': typeof AuthenticatedUserManagementCompaniesIndexRoute
  '/_unauthenticated/register/$invitedToken/': typeof UnauthenticatedRegisterInvitedTokenIndexRoute
  '/_unauthenticated/register/verification-code/': typeof UnauthenticatedRegisterVerificationCodeIndexRoute
  '/home/$mode/$token/': typeof HomeModeTokenIndexRoute
  '/_authenticated/project/$projectId/$planId/_viewer': typeof AuthenticatedProjectProjectIdPlanIdViewerRouteRouteWithChildren
  '/_authenticated/project/$projectId/pins/$viewType': typeof AuthenticatedProjectProjectIdPinsViewTypeRouteRouteWithChildren
  '/_authenticated/project/$projectId/_plans/': typeof AuthenticatedProjectProjectIdPlansIndexRoute
  '/_authenticated/project/$projectId/datasets/': typeof AuthenticatedProjectProjectIdDatasetsIndexRoute
  '/_authenticated/project/$projectId/groups/': typeof AuthenticatedProjectProjectIdGroupsIndexRoute
  '/_authenticated/project/$projectId/media/': typeof AuthenticatedProjectProjectIdMediaIndexRoute
  '/_authenticated/project/$projectId/tasks/': typeof AuthenticatedProjectProjectIdTasksIndexRoute
  '/_authenticated/project/$projectId/team/': typeof AuthenticatedProjectProjectIdTeamIndexRoute
  '/_authenticated/project/_projects/copy/': typeof AuthenticatedProjectProjectsCopyIndexRoute
  '/_authenticated/project/_projects/new/': typeof AuthenticatedProjectProjectsNewIndexRoute
  '/_authenticated/project/_projects/newfolder/': typeof AuthenticatedProjectProjectsNewfolderIndexRoute
  '/_authenticated/project/_projects/rename/': typeof AuthenticatedProjectProjectsRenameIndexRoute
  '/_authenticated/userManagement/folderRestriction/$userId/': typeof AuthenticatedUserManagementFolderRestrictionUserIdIndexRoute
  '/_unauthenticated/activate/$type/$token/': typeof UnauthenticatedActivateTypeTokenIndexRoute
  '/_authenticated/project/$projectId/groups/$groupId/$viewType': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypeRouteRouteWithChildren
  '/_authenticated/project/$projectId/_plans/import/': typeof AuthenticatedProjectProjectIdPlansImportIndexRoute
  '/_authenticated/project/$projectId/_plans/newfolder/': typeof AuthenticatedProjectProjectIdPlansNewfolderIndexRoute
  '/_authenticated/project/$projectId/_plans/rename/': typeof AuthenticatedProjectProjectIdPlansRenameIndexRoute
  '/_authenticated/project/$projectId/_plans/upgrade/': typeof AuthenticatedProjectProjectIdPlansUpgradeIndexRoute
  '/_authenticated/project/$projectId/datasets/$datasetId/': typeof AuthenticatedProjectProjectIdDatasetsDatasetIdIndexRoute
  '/_authenticated/project/$projectId/reports/$reportId/': typeof AuthenticatedProjectProjectIdReportsReportIdIndexRoute
  '/_authenticated/project/$projectId/reports/newReport/': typeof AuthenticatedProjectProjectIdReportsNewReportIndexRoute
  '/_authenticated/project/$projectId/tasks/new/': typeof AuthenticatedProjectProjectIdTasksNewIndexRoute
  '/_authenticated/project/_projects/info/$projectId/': typeof AuthenticatedProjectProjectsInfoProjectIdIndexRoute
  '/_authenticated/project/_projects/settings/$projectId/': typeof AuthenticatedProjectProjectsSettingsProjectIdIndexRoute
  '/_authenticated/userManagement/user/$userId/edit/': typeof AuthenticatedUserManagementUserUserIdEditIndexRoute
  '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRouteWithChildren
  '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRouteWithChildren
  '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRouteWithChildren
  '/_authenticated/project/$projectId/$planId/_viewer/$viewType/': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypeIndexRoute
  '/_authenticated/project/$projectId/_plans/exportPlan/$planId/': typeof AuthenticatedProjectProjectIdPlansExportPlanPlanIdIndexRoute
  '/_authenticated/project/$projectId/_plans/importRevision/$planId/': typeof AuthenticatedProjectProjectIdPlansImportRevisionPlanIdIndexRoute
  '/_authenticated/project/$projectId/_plans/planVersions/$planId/': typeof AuthenticatedProjectProjectIdPlansPlanVersionsPlanIdIndexRoute
  '/_authenticated/project/$projectId/groups/$groupId/$viewType/': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypeIndexRoute
  '/_authenticated/project/$projectId/pins/$viewType/$planId/': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdIndexRoute
  '/_authenticated/project/$projectId/pins/$viewType/noPlan/': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanIndexRoute
  '/_authenticated/project/$projectId/reports/share/$reportId/': typeof AuthenticatedProjectProjectIdReportsShareReportIdIndexRoute
  '/_authenticated/project/_projects/move/folder/$folderId/': typeof AuthenticatedProjectProjectsMoveFolderFolderIdIndexRoute
  '/_authenticated/project/_projects/move/project/$projectId/': typeof AuthenticatedProjectProjectsMoveProjectProjectIdIndexRoute
  '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRouteWithChildren
  '/_authenticated/project/$projectId/_plans/move/folder/$itemId/': typeof AuthenticatedProjectProjectIdPlansMoveFolderItemIdIndexRoute
  '/_authenticated/project/$projectId/_plans/move/plan/$itemId/': typeof AuthenticatedProjectProjectIdPlansMovePlanItemIdIndexRoute
  '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdIndexRoute
  '/_authenticated/project/$projectId/media/gallery/$year/$month/$fileId/': typeof AuthenticatedProjectProjectIdMediaGalleryYearMonthFileIdIndexRoute
  '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/task-details/$taskId': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRouteWithChildren
  '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteWithChildren
  '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRouteWithChildren
  '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/create-task/': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskCreateTaskIndexRoute
  '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/create-task/': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskCreateTaskIndexRoute
  '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/create-task/': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskCreateTaskIndexRoute
  '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteWithChildren
  '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/gallery/$postId/$fileId/': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdGalleryPostIdFileIdIndexRoute
  '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/create-task/select-assignee/': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskCreateTaskSelectAssigneeIndexRoute
  '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/create-task/': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskCreateTaskIndexRoute
  '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/gallery/$postId/$fileId/': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdGalleryPostIdFileIdIndexRoute
  '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/create-task/select-assignee/': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskCreateTaskSelectAssigneeIndexRoute
  '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/gallery/$postId/$fileId/': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdGalleryPostIdFileIdIndexRoute
  '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/create-task/select-assignee/': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskCreateTaskSelectAssigneeIndexRoute
  '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/allVisuals/gallery/$postId/$fileId/': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdAllVisualsGalleryPostIdFileIdIndexRoute
  '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/task-details/$taskId/change-assignee/': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute
  '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/gallery/$postId/$fileId/': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdGalleryPostIdFileIdIndexRoute
  '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/create-task/select-assignee/': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskCreateTaskSelectAssigneeIndexRoute
  '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/allVisuals/gallery/$postId/$fileId/': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdAllVisualsGalleryPostIdFileIdIndexRoute
  '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/change-assignee/': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute
  '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/allVisuals/gallery/$postId/$fileId/': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdAllVisualsGalleryPostIdFileIdIndexRoute
  '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/change-assignee/': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute
  '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/task-details/$taskId/edit-comment/$id/': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute
  '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/allVisuals/gallery/$postId/$fileId/': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdAllVisualsGalleryPostIdFileIdIndexRoute
  '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/change-assignee/': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute
  '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/edit-comment/$id/': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute
  '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/edit-comment/$id/': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute
  '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/': typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute
  '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/edit-comment/$id/': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute
  '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/': typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute
  '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/': typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute
  '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/': typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/project'
    | '/userManagement'
    | '/$'
    | '/project/$projectId'
    | '/home/'
    | '/reportTemplates/'
    | '/upgrade/'
    | '/userSettings/'
    | '/idpSelection/'
    | '/login/'
    | '/register/'
    | '/samlLogin/'
    | '/ssoSelection/'
    | '/home/$mode/'
    | '/project/$projectId/datasets'
    | '/project/$projectId/media'
    | '/project/$projectId/reports'
    | '/project/$projectId/tasks'
    | '/project/'
    | '/userManagement/companies/'
    | '/register/$invitedToken/'
    | '/register/verification-code/'
    | '/home/$mode/$token/'
    | '/project/$projectId/$planId'
    | '/project/$projectId/pins/$viewType'
    | '/project/$projectId/'
    | '/project/$projectId/datasets/'
    | '/project/$projectId/groups/'
    | '/project/$projectId/media/'
    | '/project/$projectId/tasks/'
    | '/project/$projectId/team/'
    | '/project/copy/'
    | '/project/new/'
    | '/project/newfolder/'
    | '/project/rename/'
    | '/userManagement/folderRestriction/$userId/'
    | '/activate/$type/$token/'
    | '/project/$projectId/groups/$groupId/$viewType'
    | '/project/$projectId/import/'
    | '/project/$projectId/newfolder/'
    | '/project/$projectId/rename/'
    | '/project/$projectId/upgrade/'
    | '/project/$projectId/datasets/$datasetId/'
    | '/project/$projectId/reports/$reportId/'
    | '/project/$projectId/reports/newReport/'
    | '/project/$projectId/tasks/new/'
    | '/project/info/$projectId/'
    | '/project/settings/$projectId/'
    | '/userManagement/user/$userId/edit/'
    | '/project/$projectId/$planId/$viewType/$pinId'
    | '/project/$projectId/pins/$viewType/$planId/$pinId'
    | '/project/$projectId/pins/$viewType/noPlan/$pinId'
    | '/project/$projectId/$planId/$viewType/'
    | '/project/$projectId/exportPlan/$planId/'
    | '/project/$projectId/importRevision/$planId/'
    | '/project/$projectId/planVersions/$planId/'
    | '/project/$projectId/groups/$groupId/$viewType/'
    | '/project/$projectId/pins/$viewType/$planId/'
    | '/project/$projectId/pins/$viewType/noPlan/'
    | '/project/$projectId/reports/share/$reportId/'
    | '/project/move/folder/$folderId/'
    | '/project/move/project/$projectId/'
    | '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId'
    | '/project/$projectId/move/folder/$itemId/'
    | '/project/$projectId/move/plan/$itemId/'
    | '/project/$projectId/groups/$groupId/$viewType/$planId/'
    | '/project/$projectId/media/gallery/$year/$month/$fileId/'
    | '/project/$projectId/$planId/$viewType/$pinId/task/task-details/$taskId'
    | '/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId'
    | '/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId'
    | '/project/$projectId/$planId/$viewType/$pinId/task/create-task/'
    | '/project/$projectId/pins/$viewType/$planId/$pinId/task/create-task/'
    | '/project/$projectId/pins/$viewType/noPlan/$pinId/task/create-task/'
    | '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId'
    | '/project/$projectId/$planId/$viewType/$pinId/gallery/$postId/$fileId/'
    | '/project/$projectId/$planId/$viewType/$pinId/task/create-task/select-assignee/'
    | '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/create-task/'
    | '/project/$projectId/pins/$viewType/$planId/$pinId/gallery/$postId/$fileId/'
    | '/project/$projectId/pins/$viewType/$planId/$pinId/task/create-task/select-assignee/'
    | '/project/$projectId/pins/$viewType/noPlan/$pinId/gallery/$postId/$fileId/'
    | '/project/$projectId/pins/$viewType/noPlan/$pinId/task/create-task/select-assignee/'
    | '/project/$projectId/$planId/$viewType/$pinId/allVisuals/gallery/$postId/$fileId/'
    | '/project/$projectId/$planId/$viewType/$pinId/task/task-details/$taskId/change-assignee/'
    | '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/gallery/$postId/$fileId/'
    | '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/create-task/select-assignee/'
    | '/project/$projectId/pins/$viewType/$planId/$pinId/allVisuals/gallery/$postId/$fileId/'
    | '/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/change-assignee/'
    | '/project/$projectId/pins/$viewType/noPlan/$pinId/allVisuals/gallery/$postId/$fileId/'
    | '/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/change-assignee/'
    | '/project/$projectId/$planId/$viewType/$pinId/task/task-details/$taskId/edit-comment/$id/'
    | '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/allVisuals/gallery/$postId/$fileId/'
    | '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/change-assignee/'
    | '/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/edit-comment/$id/'
    | '/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/edit-comment/$id/'
    | '/project/$projectId/$planId/$viewType/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/'
    | '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/edit-comment/$id/'
    | '/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/'
    | '/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/'
    | '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/project'
    | '/userManagement'
    | '/$'
    | '/project/$projectId'
    | '/home'
    | '/reportTemplates'
    | '/upgrade'
    | '/userSettings'
    | '/idpSelection'
    | '/login'
    | '/register'
    | '/samlLogin'
    | '/ssoSelection'
    | '/home/$mode'
    | '/project/$projectId/reports'
    | '/userManagement/companies'
    | '/register/$invitedToken'
    | '/register/verification-code'
    | '/home/$mode/$token'
    | '/project/$projectId/$planId'
    | '/project/$projectId/pins/$viewType'
    | '/project/$projectId/datasets'
    | '/project/$projectId/groups'
    | '/project/$projectId/media'
    | '/project/$projectId/tasks'
    | '/project/$projectId/team'
    | '/project/copy'
    | '/project/new'
    | '/project/newfolder'
    | '/project/rename'
    | '/userManagement/folderRestriction/$userId'
    | '/activate/$type/$token'
    | '/project/$projectId/import'
    | '/project/$projectId/newfolder'
    | '/project/$projectId/rename'
    | '/project/$projectId/upgrade'
    | '/project/$projectId/datasets/$datasetId'
    | '/project/$projectId/reports/$reportId'
    | '/project/$projectId/reports/newReport'
    | '/project/$projectId/tasks/new'
    | '/project/info/$projectId'
    | '/project/settings/$projectId'
    | '/userManagement/user/$userId/edit'
    | '/project/$projectId/$planId/$viewType/$pinId'
    | '/project/$projectId/pins/$viewType/$planId/$pinId'
    | '/project/$projectId/pins/$viewType/noPlan/$pinId'
    | '/project/$projectId/$planId/$viewType'
    | '/project/$projectId/exportPlan/$planId'
    | '/project/$projectId/importRevision/$planId'
    | '/project/$projectId/planVersions/$planId'
    | '/project/$projectId/groups/$groupId/$viewType'
    | '/project/$projectId/pins/$viewType/$planId'
    | '/project/$projectId/pins/$viewType/noPlan'
    | '/project/$projectId/reports/share/$reportId'
    | '/project/move/folder/$folderId'
    | '/project/move/project/$projectId'
    | '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId'
    | '/project/$projectId/move/folder/$itemId'
    | '/project/$projectId/move/plan/$itemId'
    | '/project/$projectId/groups/$groupId/$viewType/$planId'
    | '/project/$projectId/media/gallery/$year/$month/$fileId'
    | '/project/$projectId/$planId/$viewType/$pinId/task/task-details/$taskId'
    | '/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId'
    | '/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId'
    | '/project/$projectId/$planId/$viewType/$pinId/task/create-task'
    | '/project/$projectId/pins/$viewType/$planId/$pinId/task/create-task'
    | '/project/$projectId/pins/$viewType/noPlan/$pinId/task/create-task'
    | '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId'
    | '/project/$projectId/$planId/$viewType/$pinId/gallery/$postId/$fileId'
    | '/project/$projectId/$planId/$viewType/$pinId/task/create-task/select-assignee'
    | '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/create-task'
    | '/project/$projectId/pins/$viewType/$planId/$pinId/gallery/$postId/$fileId'
    | '/project/$projectId/pins/$viewType/$planId/$pinId/task/create-task/select-assignee'
    | '/project/$projectId/pins/$viewType/noPlan/$pinId/gallery/$postId/$fileId'
    | '/project/$projectId/pins/$viewType/noPlan/$pinId/task/create-task/select-assignee'
    | '/project/$projectId/$planId/$viewType/$pinId/allVisuals/gallery/$postId/$fileId'
    | '/project/$projectId/$planId/$viewType/$pinId/task/task-details/$taskId/change-assignee'
    | '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/gallery/$postId/$fileId'
    | '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/create-task/select-assignee'
    | '/project/$projectId/pins/$viewType/$planId/$pinId/allVisuals/gallery/$postId/$fileId'
    | '/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/change-assignee'
    | '/project/$projectId/pins/$viewType/noPlan/$pinId/allVisuals/gallery/$postId/$fileId'
    | '/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/change-assignee'
    | '/project/$projectId/$planId/$viewType/$pinId/task/task-details/$taskId/edit-comment/$id'
    | '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/allVisuals/gallery/$postId/$fileId'
    | '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/change-assignee'
    | '/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/edit-comment/$id'
    | '/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/edit-comment/$id'
    | '/project/$projectId/$planId/$viewType/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId'
    | '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/edit-comment/$id'
    | '/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId'
    | '/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId'
    | '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_unauthenticated'
    | '/_authenticated/project'
    | '/_authenticated/userManagement'
    | '/_authenticated/$'
    | '/_authenticated/project/$projectId'
    | '/_authenticated/project/_projects'
    | '/_authenticated/home/'
    | '/_authenticated/reportTemplates/'
    | '/_authenticated/upgrade/'
    | '/_authenticated/userSettings/'
    | '/_unauthenticated/idpSelection/'
    | '/_unauthenticated/login/'
    | '/_unauthenticated/register/'
    | '/_unauthenticated/samlLogin/'
    | '/_unauthenticated/ssoSelection/'
    | '/home/$mode/'
    | '/_authenticated/project/$projectId/_plans'
    | '/_authenticated/project/$projectId/datasets'
    | '/_authenticated/project/$projectId/media'
    | '/_authenticated/project/$projectId/reports'
    | '/_authenticated/project/$projectId/tasks'
    | '/_authenticated/project/_projects/'
    | '/_authenticated/userManagement/companies/'
    | '/_unauthenticated/register/$invitedToken/'
    | '/_unauthenticated/register/verification-code/'
    | '/home/$mode/$token/'
    | '/_authenticated/project/$projectId/$planId/_viewer'
    | '/_authenticated/project/$projectId/pins/$viewType'
    | '/_authenticated/project/$projectId/_plans/'
    | '/_authenticated/project/$projectId/datasets/'
    | '/_authenticated/project/$projectId/groups/'
    | '/_authenticated/project/$projectId/media/'
    | '/_authenticated/project/$projectId/tasks/'
    | '/_authenticated/project/$projectId/team/'
    | '/_authenticated/project/_projects/copy/'
    | '/_authenticated/project/_projects/new/'
    | '/_authenticated/project/_projects/newfolder/'
    | '/_authenticated/project/_projects/rename/'
    | '/_authenticated/userManagement/folderRestriction/$userId/'
    | '/_unauthenticated/activate/$type/$token/'
    | '/_authenticated/project/$projectId/groups/$groupId/$viewType'
    | '/_authenticated/project/$projectId/_plans/import/'
    | '/_authenticated/project/$projectId/_plans/newfolder/'
    | '/_authenticated/project/$projectId/_plans/rename/'
    | '/_authenticated/project/$projectId/_plans/upgrade/'
    | '/_authenticated/project/$projectId/datasets/$datasetId/'
    | '/_authenticated/project/$projectId/reports/$reportId/'
    | '/_authenticated/project/$projectId/reports/newReport/'
    | '/_authenticated/project/$projectId/tasks/new/'
    | '/_authenticated/project/_projects/info/$projectId/'
    | '/_authenticated/project/_projects/settings/$projectId/'
    | '/_authenticated/userManagement/user/$userId/edit/'
    | '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId'
    | '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId'
    | '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId'
    | '/_authenticated/project/$projectId/$planId/_viewer/$viewType/'
    | '/_authenticated/project/$projectId/_plans/exportPlan/$planId/'
    | '/_authenticated/project/$projectId/_plans/importRevision/$planId/'
    | '/_authenticated/project/$projectId/_plans/planVersions/$planId/'
    | '/_authenticated/project/$projectId/groups/$groupId/$viewType/'
    | '/_authenticated/project/$projectId/pins/$viewType/$planId/'
    | '/_authenticated/project/$projectId/pins/$viewType/noPlan/'
    | '/_authenticated/project/$projectId/reports/share/$reportId/'
    | '/_authenticated/project/_projects/move/folder/$folderId/'
    | '/_authenticated/project/_projects/move/project/$projectId/'
    | '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId'
    | '/_authenticated/project/$projectId/_plans/move/folder/$itemId/'
    | '/_authenticated/project/$projectId/_plans/move/plan/$itemId/'
    | '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/'
    | '/_authenticated/project/$projectId/media/gallery/$year/$month/$fileId/'
    | '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/task-details/$taskId'
    | '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId'
    | '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId'
    | '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/create-task/'
    | '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/create-task/'
    | '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/create-task/'
    | '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId'
    | '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/gallery/$postId/$fileId/'
    | '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/create-task/select-assignee/'
    | '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/create-task/'
    | '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/gallery/$postId/$fileId/'
    | '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/create-task/select-assignee/'
    | '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/gallery/$postId/$fileId/'
    | '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/create-task/select-assignee/'
    | '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/allVisuals/gallery/$postId/$fileId/'
    | '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/task-details/$taskId/change-assignee/'
    | '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/gallery/$postId/$fileId/'
    | '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/create-task/select-assignee/'
    | '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/allVisuals/gallery/$postId/$fileId/'
    | '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/change-assignee/'
    | '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/allVisuals/gallery/$postId/$fileId/'
    | '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/change-assignee/'
    | '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/task-details/$taskId/edit-comment/$id/'
    | '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/allVisuals/gallery/$postId/$fileId/'
    | '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/change-assignee/'
    | '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/edit-comment/$id/'
    | '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/edit-comment/$id/'
    | '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/'
    | '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/edit-comment/$id/'
    | '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/'
    | '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/'
    | '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  UnauthenticatedRouteRoute: typeof UnauthenticatedRouteRouteWithChildren
  HomeModeIndexRoute: typeof HomeModeIndexRoute
  HomeModeTokenIndexRoute: typeof HomeModeTokenIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_unauthenticated': {
      id: '/_unauthenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof UnauthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/$': {
      id: '/_authenticated/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AuthenticatedSplatRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/userManagement': {
      id: '/_authenticated/userManagement'
      path: '/userManagement'
      fullPath: '/userManagement'
      preLoaderRoute: typeof AuthenticatedUserManagementRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/project': {
      id: '/_authenticated/project'
      path: '/project'
      fullPath: '/project'
      preLoaderRoute: typeof AuthenticatedProjectRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/home/$mode/': {
      id: '/home/$mode/'
      path: '/home/$mode'
      fullPath: '/home/$mode/'
      preLoaderRoute: typeof HomeModeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated/ssoSelection/': {
      id: '/_unauthenticated/ssoSelection/'
      path: '/ssoSelection'
      fullPath: '/ssoSelection/'
      preLoaderRoute: typeof UnauthenticatedSsoSelectionIndexRouteImport
      parentRoute: typeof UnauthenticatedRouteRoute
    }
    '/_unauthenticated/samlLogin/': {
      id: '/_unauthenticated/samlLogin/'
      path: '/samlLogin'
      fullPath: '/samlLogin/'
      preLoaderRoute: typeof UnauthenticatedSamlLoginIndexRouteImport
      parentRoute: typeof UnauthenticatedRouteRoute
    }
    '/_unauthenticated/register/': {
      id: '/_unauthenticated/register/'
      path: '/register'
      fullPath: '/register/'
      preLoaderRoute: typeof UnauthenticatedRegisterIndexRouteImport
      parentRoute: typeof UnauthenticatedRouteRoute
    }
    '/_unauthenticated/login/': {
      id: '/_unauthenticated/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof UnauthenticatedLoginIndexRouteImport
      parentRoute: typeof UnauthenticatedRouteRoute
    }
    '/_unauthenticated/idpSelection/': {
      id: '/_unauthenticated/idpSelection/'
      path: '/idpSelection'
      fullPath: '/idpSelection/'
      preLoaderRoute: typeof UnauthenticatedIdpSelectionIndexRouteImport
      parentRoute: typeof UnauthenticatedRouteRoute
    }
    '/_authenticated/userSettings/': {
      id: '/_authenticated/userSettings/'
      path: '/userSettings'
      fullPath: '/userSettings/'
      preLoaderRoute: typeof AuthenticatedUserSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/upgrade/': {
      id: '/_authenticated/upgrade/'
      path: '/upgrade'
      fullPath: '/upgrade/'
      preLoaderRoute: typeof AuthenticatedUpgradeIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/reportTemplates/': {
      id: '/_authenticated/reportTemplates/'
      path: '/reportTemplates'
      fullPath: '/reportTemplates/'
      preLoaderRoute: typeof AuthenticatedReportTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/home/': {
      id: '/_authenticated/home/'
      path: '/home'
      fullPath: '/home/'
      preLoaderRoute: typeof AuthenticatedHomeIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/project/_projects': {
      id: '/_authenticated/project/_projects'
      path: ''
      fullPath: '/project'
      preLoaderRoute: typeof AuthenticatedProjectProjectsRouteRouteImport
      parentRoute: typeof AuthenticatedProjectRouteRoute
    }
    '/_authenticated/project/$projectId': {
      id: '/_authenticated/project/$projectId'
      path: '/$projectId'
      fullPath: '/project/$projectId'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdRouteRouteImport
      parentRoute: typeof AuthenticatedProjectRouteRoute
    }
    '/home/$mode/$token/': {
      id: '/home/$mode/$token/'
      path: '/home/$mode/$token'
      fullPath: '/home/$mode/$token/'
      preLoaderRoute: typeof HomeModeTokenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated/register/verification-code/': {
      id: '/_unauthenticated/register/verification-code/'
      path: '/register/verification-code'
      fullPath: '/register/verification-code/'
      preLoaderRoute: typeof UnauthenticatedRegisterVerificationCodeIndexRouteImport
      parentRoute: typeof UnauthenticatedRouteRoute
    }
    '/_unauthenticated/register/$invitedToken/': {
      id: '/_unauthenticated/register/$invitedToken/'
      path: '/register/$invitedToken'
      fullPath: '/register/$invitedToken/'
      preLoaderRoute: typeof UnauthenticatedRegisterInvitedTokenIndexRouteImport
      parentRoute: typeof UnauthenticatedRouteRoute
    }
    '/_authenticated/userManagement/companies/': {
      id: '/_authenticated/userManagement/companies/'
      path: '/companies'
      fullPath: '/userManagement/companies/'
      preLoaderRoute: typeof AuthenticatedUserManagementCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedUserManagementRouteRoute
    }
    '/_authenticated/project/_projects/': {
      id: '/_authenticated/project/_projects/'
      path: '/'
      fullPath: '/project/'
      preLoaderRoute: typeof AuthenticatedProjectProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectsRouteRoute
    }
    '/_authenticated/project/$projectId/tasks': {
      id: '/_authenticated/project/$projectId/tasks'
      path: '/tasks'
      fullPath: '/project/$projectId/tasks'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdTasksRouteRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdRouteRoute
    }
    '/_authenticated/project/$projectId/reports': {
      id: '/_authenticated/project/$projectId/reports'
      path: '/reports'
      fullPath: '/project/$projectId/reports'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdReportsRouteRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdRouteRoute
    }
    '/_authenticated/project/$projectId/media': {
      id: '/_authenticated/project/$projectId/media'
      path: '/media'
      fullPath: '/project/$projectId/media'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdMediaRouteRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdRouteRoute
    }
    '/_authenticated/project/$projectId/datasets': {
      id: '/_authenticated/project/$projectId/datasets'
      path: '/datasets'
      fullPath: '/project/$projectId/datasets'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdDatasetsRouteRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdRouteRoute
    }
    '/_authenticated/project/$projectId/_plans': {
      id: '/_authenticated/project/$projectId/_plans'
      path: ''
      fullPath: '/project/$projectId'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPlansRouteRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdRouteRoute
    }
    '/_unauthenticated/activate/$type/$token/': {
      id: '/_unauthenticated/activate/$type/$token/'
      path: '/activate/$type/$token'
      fullPath: '/activate/$type/$token/'
      preLoaderRoute: typeof UnauthenticatedActivateTypeTokenIndexRouteImport
      parentRoute: typeof UnauthenticatedRouteRoute
    }
    '/_authenticated/userManagement/folderRestriction/$userId/': {
      id: '/_authenticated/userManagement/folderRestriction/$userId/'
      path: '/folderRestriction/$userId'
      fullPath: '/userManagement/folderRestriction/$userId/'
      preLoaderRoute: typeof AuthenticatedUserManagementFolderRestrictionUserIdIndexRouteImport
      parentRoute: typeof AuthenticatedUserManagementRouteRoute
    }
    '/_authenticated/project/_projects/rename/': {
      id: '/_authenticated/project/_projects/rename/'
      path: '/rename'
      fullPath: '/project/rename/'
      preLoaderRoute: typeof AuthenticatedProjectProjectsRenameIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectsRouteRoute
    }
    '/_authenticated/project/_projects/newfolder/': {
      id: '/_authenticated/project/_projects/newfolder/'
      path: '/newfolder'
      fullPath: '/project/newfolder/'
      preLoaderRoute: typeof AuthenticatedProjectProjectsNewfolderIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectsRouteRoute
    }
    '/_authenticated/project/_projects/new/': {
      id: '/_authenticated/project/_projects/new/'
      path: '/new'
      fullPath: '/project/new/'
      preLoaderRoute: typeof AuthenticatedProjectProjectsNewIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectsRouteRoute
    }
    '/_authenticated/project/_projects/copy/': {
      id: '/_authenticated/project/_projects/copy/'
      path: '/copy'
      fullPath: '/project/copy/'
      preLoaderRoute: typeof AuthenticatedProjectProjectsCopyIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectsRouteRoute
    }
    '/_authenticated/project/$projectId/team/': {
      id: '/_authenticated/project/$projectId/team/'
      path: '/team'
      fullPath: '/project/$projectId/team/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdTeamIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdRouteRoute
    }
    '/_authenticated/project/$projectId/tasks/': {
      id: '/_authenticated/project/$projectId/tasks/'
      path: '/'
      fullPath: '/project/$projectId/tasks/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdTasksIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdTasksRouteRoute
    }
    '/_authenticated/project/$projectId/media/': {
      id: '/_authenticated/project/$projectId/media/'
      path: '/'
      fullPath: '/project/$projectId/media/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdMediaIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdMediaRouteRoute
    }
    '/_authenticated/project/$projectId/groups/': {
      id: '/_authenticated/project/$projectId/groups/'
      path: '/groups'
      fullPath: '/project/$projectId/groups/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdGroupsIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdRouteRoute
    }
    '/_authenticated/project/$projectId/datasets/': {
      id: '/_authenticated/project/$projectId/datasets/'
      path: '/'
      fullPath: '/project/$projectId/datasets/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdDatasetsIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdDatasetsRouteRoute
    }
    '/_authenticated/project/$projectId/_plans/': {
      id: '/_authenticated/project/$projectId/_plans/'
      path: '/'
      fullPath: '/project/$projectId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPlansIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPlansRouteRoute
    }
    '/_authenticated/project/$projectId/pins/$viewType': {
      id: '/_authenticated/project/$projectId/pins/$viewType'
      path: '/pins/$viewType'
      fullPath: '/project/$projectId/pins/$viewType'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeRouteRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdRouteRoute
    }
    '/_authenticated/project/$projectId/$planId/_viewer': {
      id: '/_authenticated/project/$projectId/$planId/_viewer'
      path: '/$planId'
      fullPath: '/project/$projectId/$planId'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerRouteRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdRouteRoute
    }
    '/_authenticated/userManagement/user/$userId/edit/': {
      id: '/_authenticated/userManagement/user/$userId/edit/'
      path: '/user/$userId/edit'
      fullPath: '/userManagement/user/$userId/edit/'
      preLoaderRoute: typeof AuthenticatedUserManagementUserUserIdEditIndexRouteImport
      parentRoute: typeof AuthenticatedUserManagementRouteRoute
    }
    '/_authenticated/project/_projects/settings/$projectId/': {
      id: '/_authenticated/project/_projects/settings/$projectId/'
      path: '/settings/$projectId'
      fullPath: '/project/settings/$projectId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectsSettingsProjectIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectsRouteRoute
    }
    '/_authenticated/project/_projects/info/$projectId/': {
      id: '/_authenticated/project/_projects/info/$projectId/'
      path: '/info/$projectId'
      fullPath: '/project/info/$projectId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectsInfoProjectIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectsRouteRoute
    }
    '/_authenticated/project/$projectId/tasks/new/': {
      id: '/_authenticated/project/$projectId/tasks/new/'
      path: '/new'
      fullPath: '/project/$projectId/tasks/new/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdTasksNewIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdTasksRouteRoute
    }
    '/_authenticated/project/$projectId/reports/newReport/': {
      id: '/_authenticated/project/$projectId/reports/newReport/'
      path: '/newReport'
      fullPath: '/project/$projectId/reports/newReport/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdReportsNewReportIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdReportsRouteRoute
    }
    '/_authenticated/project/$projectId/reports/$reportId/': {
      id: '/_authenticated/project/$projectId/reports/$reportId/'
      path: '/$reportId'
      fullPath: '/project/$projectId/reports/$reportId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdReportsReportIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdReportsRouteRoute
    }
    '/_authenticated/project/$projectId/datasets/$datasetId/': {
      id: '/_authenticated/project/$projectId/datasets/$datasetId/'
      path: '/$datasetId'
      fullPath: '/project/$projectId/datasets/$datasetId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdDatasetsDatasetIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdDatasetsRouteRoute
    }
    '/_authenticated/project/$projectId/_plans/upgrade/': {
      id: '/_authenticated/project/$projectId/_plans/upgrade/'
      path: '/upgrade'
      fullPath: '/project/$projectId/upgrade/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPlansUpgradeIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPlansRouteRoute
    }
    '/_authenticated/project/$projectId/_plans/rename/': {
      id: '/_authenticated/project/$projectId/_plans/rename/'
      path: '/rename'
      fullPath: '/project/$projectId/rename/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPlansRenameIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPlansRouteRoute
    }
    '/_authenticated/project/$projectId/_plans/newfolder/': {
      id: '/_authenticated/project/$projectId/_plans/newfolder/'
      path: '/newfolder'
      fullPath: '/project/$projectId/newfolder/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPlansNewfolderIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPlansRouteRoute
    }
    '/_authenticated/project/$projectId/_plans/import/': {
      id: '/_authenticated/project/$projectId/_plans/import/'
      path: '/import'
      fullPath: '/project/$projectId/import/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPlansImportIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPlansRouteRoute
    }
    '/_authenticated/project/$projectId/groups/$groupId/$viewType': {
      id: '/_authenticated/project/$projectId/groups/$groupId/$viewType'
      path: '/groups/$groupId/$viewType'
      fullPath: '/project/$projectId/groups/$groupId/$viewType'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypeRouteRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdRouteRoute
    }
    '/_authenticated/project/_projects/move/project/$projectId/': {
      id: '/_authenticated/project/_projects/move/project/$projectId/'
      path: '/move/project/$projectId'
      fullPath: '/project/move/project/$projectId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectsMoveProjectProjectIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectsRouteRoute
    }
    '/_authenticated/project/_projects/move/folder/$folderId/': {
      id: '/_authenticated/project/_projects/move/folder/$folderId/'
      path: '/move/folder/$folderId'
      fullPath: '/project/move/folder/$folderId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectsMoveFolderFolderIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectsRouteRoute
    }
    '/_authenticated/project/$projectId/reports/share/$reportId/': {
      id: '/_authenticated/project/$projectId/reports/share/$reportId/'
      path: '/share/$reportId'
      fullPath: '/project/$projectId/reports/share/$reportId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdReportsShareReportIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdReportsRouteRoute
    }
    '/_authenticated/project/$projectId/pins/$viewType/noPlan/': {
      id: '/_authenticated/project/$projectId/pins/$viewType/noPlan/'
      path: '/noPlan'
      fullPath: '/project/$projectId/pins/$viewType/noPlan/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeRouteRoute
    }
    '/_authenticated/project/$projectId/pins/$viewType/$planId/': {
      id: '/_authenticated/project/$projectId/pins/$viewType/$planId/'
      path: '/$planId'
      fullPath: '/project/$projectId/pins/$viewType/$planId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeRouteRoute
    }
    '/_authenticated/project/$projectId/groups/$groupId/$viewType/': {
      id: '/_authenticated/project/$projectId/groups/$groupId/$viewType/'
      path: '/'
      fullPath: '/project/$projectId/groups/$groupId/$viewType/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypeIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypeRouteRoute
    }
    '/_authenticated/project/$projectId/_plans/planVersions/$planId/': {
      id: '/_authenticated/project/$projectId/_plans/planVersions/$planId/'
      path: '/planVersions/$planId'
      fullPath: '/project/$projectId/planVersions/$planId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPlansPlanVersionsPlanIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPlansRouteRoute
    }
    '/_authenticated/project/$projectId/_plans/importRevision/$planId/': {
      id: '/_authenticated/project/$projectId/_plans/importRevision/$planId/'
      path: '/importRevision/$planId'
      fullPath: '/project/$projectId/importRevision/$planId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPlansImportRevisionPlanIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPlansRouteRoute
    }
    '/_authenticated/project/$projectId/_plans/exportPlan/$planId/': {
      id: '/_authenticated/project/$projectId/_plans/exportPlan/$planId/'
      path: '/exportPlan/$planId'
      fullPath: '/project/$projectId/exportPlan/$planId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPlansExportPlanPlanIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPlansRouteRoute
    }
    '/_authenticated/project/$projectId/$planId/_viewer/$viewType/': {
      id: '/_authenticated/project/$projectId/$planId/_viewer/$viewType/'
      path: '/$viewType'
      fullPath: '/project/$projectId/$planId/$viewType/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypeIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerRouteRoute
    }
    '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId': {
      id: '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId'
      path: '/noPlan/$pinId'
      fullPath: '/project/$projectId/pins/$viewType/noPlan/$pinId'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeRouteRoute
    }
    '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId': {
      id: '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId'
      path: '/$planId/$pinId'
      fullPath: '/project/$projectId/pins/$viewType/$planId/$pinId'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeRouteRoute
    }
    '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId': {
      id: '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId'
      path: '/$viewType/$pinId'
      fullPath: '/project/$projectId/$planId/$viewType/$pinId'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerRouteRoute
    }
    '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/': {
      id: '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/'
      path: '/$planId'
      fullPath: '/project/$projectId/groups/$groupId/$viewType/$planId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypeRouteRoute
    }
    '/_authenticated/project/$projectId/_plans/move/plan/$itemId/': {
      id: '/_authenticated/project/$projectId/_plans/move/plan/$itemId/'
      path: '/move/plan/$itemId'
      fullPath: '/project/$projectId/move/plan/$itemId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPlansMovePlanItemIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPlansRouteRoute
    }
    '/_authenticated/project/$projectId/_plans/move/folder/$itemId/': {
      id: '/_authenticated/project/$projectId/_plans/move/folder/$itemId/'
      path: '/move/folder/$itemId'
      fullPath: '/project/$projectId/move/folder/$itemId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPlansMoveFolderItemIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPlansRouteRoute
    }
    '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId': {
      id: '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId'
      path: '/$planId/$pinId'
      fullPath: '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypeRouteRoute
    }
    '/_authenticated/project/$projectId/media/gallery/$year/$month/$fileId/': {
      id: '/_authenticated/project/$projectId/media/gallery/$year/$month/$fileId/'
      path: '/gallery/$year/$month/$fileId'
      fullPath: '/project/$projectId/media/gallery/$year/$month/$fileId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdMediaGalleryYearMonthFileIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdMediaRouteRoute
    }
    '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/create-task/': {
      id: '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/create-task/'
      path: '/task/create-task'
      fullPath: '/project/$projectId/pins/$viewType/noPlan/$pinId/task/create-task/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskCreateTaskIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRoute
    }
    '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/create-task/': {
      id: '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/create-task/'
      path: '/task/create-task'
      fullPath: '/project/$projectId/pins/$viewType/$planId/$pinId/task/create-task/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskCreateTaskIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRoute
    }
    '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/create-task/': {
      id: '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/create-task/'
      path: '/task/create-task'
      fullPath: '/project/$projectId/$planId/$viewType/$pinId/task/create-task/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskCreateTaskIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRoute
    }
    '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId': {
      id: '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId'
      path: '/task/task-details/$taskId'
      fullPath: '/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRoute
    }
    '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId': {
      id: '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId'
      path: '/task/task-details/$taskId'
      fullPath: '/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRoute
    }
    '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/task-details/$taskId': {
      id: '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/task-details/$taskId'
      path: '/task/task-details/$taskId'
      fullPath: '/project/$projectId/$planId/$viewType/$pinId/task/task-details/$taskId'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRoute
    }
    '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/create-task/select-assignee/': {
      id: '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/create-task/select-assignee/'
      path: '/task/create-task/select-assignee'
      fullPath: '/project/$projectId/pins/$viewType/noPlan/$pinId/task/create-task/select-assignee/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskCreateTaskSelectAssigneeIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRoute
    }
    '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/gallery/$postId/$fileId/': {
      id: '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/gallery/$postId/$fileId/'
      path: '/gallery/$postId/$fileId'
      fullPath: '/project/$projectId/pins/$viewType/noPlan/$pinId/gallery/$postId/$fileId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdGalleryPostIdFileIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRoute
    }
    '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/create-task/select-assignee/': {
      id: '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/create-task/select-assignee/'
      path: '/task/create-task/select-assignee'
      fullPath: '/project/$projectId/pins/$viewType/$planId/$pinId/task/create-task/select-assignee/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskCreateTaskSelectAssigneeIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRoute
    }
    '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/gallery/$postId/$fileId/': {
      id: '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/gallery/$postId/$fileId/'
      path: '/gallery/$postId/$fileId'
      fullPath: '/project/$projectId/pins/$viewType/$planId/$pinId/gallery/$postId/$fileId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdGalleryPostIdFileIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRoute
    }
    '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/create-task/': {
      id: '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/create-task/'
      path: '/task/create-task'
      fullPath: '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/create-task/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskCreateTaskIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRoute
    }
    '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/create-task/select-assignee/': {
      id: '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/create-task/select-assignee/'
      path: '/task/create-task/select-assignee'
      fullPath: '/project/$projectId/$planId/$viewType/$pinId/task/create-task/select-assignee/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskCreateTaskSelectAssigneeIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRoute
    }
    '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/gallery/$postId/$fileId/': {
      id: '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/gallery/$postId/$fileId/'
      path: '/gallery/$postId/$fileId'
      fullPath: '/project/$projectId/$planId/$viewType/$pinId/gallery/$postId/$fileId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdGalleryPostIdFileIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRoute
    }
    '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId': {
      id: '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId'
      path: '/task/task-details/$taskId'
      fullPath: '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRoute
    }
    '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/change-assignee/': {
      id: '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/change-assignee/'
      path: '/change-assignee'
      fullPath: '/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/change-assignee/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRoute
    }
    '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/allVisuals/gallery/$postId/$fileId/': {
      id: '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/allVisuals/gallery/$postId/$fileId/'
      path: '/allVisuals/gallery/$postId/$fileId'
      fullPath: '/project/$projectId/pins/$viewType/noPlan/$pinId/allVisuals/gallery/$postId/$fileId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdAllVisualsGalleryPostIdFileIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRoute
    }
    '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/change-assignee/': {
      id: '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/change-assignee/'
      path: '/change-assignee'
      fullPath: '/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/change-assignee/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRoute
    }
    '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/allVisuals/gallery/$postId/$fileId/': {
      id: '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/allVisuals/gallery/$postId/$fileId/'
      path: '/allVisuals/gallery/$postId/$fileId'
      fullPath: '/project/$projectId/pins/$viewType/$planId/$pinId/allVisuals/gallery/$postId/$fileId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdAllVisualsGalleryPostIdFileIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRoute
    }
    '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/create-task/select-assignee/': {
      id: '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/create-task/select-assignee/'
      path: '/task/create-task/select-assignee'
      fullPath: '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/create-task/select-assignee/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskCreateTaskSelectAssigneeIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRoute
    }
    '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/gallery/$postId/$fileId/': {
      id: '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/gallery/$postId/$fileId/'
      path: '/gallery/$postId/$fileId'
      fullPath: '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/gallery/$postId/$fileId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdGalleryPostIdFileIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRoute
    }
    '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/task-details/$taskId/change-assignee/': {
      id: '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/task-details/$taskId/change-assignee/'
      path: '/change-assignee'
      fullPath: '/project/$projectId/$planId/$viewType/$pinId/task/task-details/$taskId/change-assignee/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRoute
    }
    '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/allVisuals/gallery/$postId/$fileId/': {
      id: '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/allVisuals/gallery/$postId/$fileId/'
      path: '/allVisuals/gallery/$postId/$fileId'
      fullPath: '/project/$projectId/$planId/$viewType/$pinId/allVisuals/gallery/$postId/$fileId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdAllVisualsGalleryPostIdFileIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRoute
    }
    '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/edit-comment/$id/': {
      id: '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/edit-comment/$id/'
      path: '/edit-comment/$id'
      fullPath: '/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/edit-comment/$id/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRoute
    }
    '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/edit-comment/$id/': {
      id: '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/edit-comment/$id/'
      path: '/edit-comment/$id'
      fullPath: '/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/edit-comment/$id/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRoute
    }
    '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/change-assignee/': {
      id: '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/change-assignee/'
      path: '/change-assignee'
      fullPath: '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/change-assignee/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRoute
    }
    '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/allVisuals/gallery/$postId/$fileId/': {
      id: '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/allVisuals/gallery/$postId/$fileId/'
      path: '/allVisuals/gallery/$postId/$fileId'
      fullPath: '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/allVisuals/gallery/$postId/$fileId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdAllVisualsGalleryPostIdFileIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRoute
    }
    '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/task-details/$taskId/edit-comment/$id/': {
      id: '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/task-details/$taskId/edit-comment/$id/'
      path: '/edit-comment/$id'
      fullPath: '/project/$projectId/$planId/$viewType/$pinId/task/task-details/$taskId/edit-comment/$id/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdEditCommentIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRoute
    }
    '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/': {
      id: '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/'
      path: '/comment-gallery/$fileId/$commentId'
      fullPath: '/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRoute
    }
    '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/': {
      id: '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/'
      path: '/comment-gallery/$fileId/$commentId'
      fullPath: '/project/$projectId/pins/$viewType/$planId/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRoute
    }
    '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/edit-comment/$id/': {
      id: '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/edit-comment/$id/'
      path: '/edit-comment/$id'
      fullPath: '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/edit-comment/$id/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRoute
    }
    '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/': {
      id: '/_authenticated/project/$projectId/$planId/_viewer/$viewType/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/'
      path: '/comment-gallery/$fileId/$commentId'
      fullPath: '/project/$projectId/$planId/$viewType/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRoute
    }
    '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/': {
      id: '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/'
      path: '/comment-gallery/$fileId/$commentId'
      fullPath: '/project/$projectId/groups/$groupId/$viewType/$planId/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRoute
    }
  }
}

interface AuthenticatedProjectProjectIdPlansRouteRouteChildren {
  AuthenticatedProjectProjectIdPlansIndexRoute: typeof AuthenticatedProjectProjectIdPlansIndexRoute
  AuthenticatedProjectProjectIdPlansImportIndexRoute: typeof AuthenticatedProjectProjectIdPlansImportIndexRoute
  AuthenticatedProjectProjectIdPlansNewfolderIndexRoute: typeof AuthenticatedProjectProjectIdPlansNewfolderIndexRoute
  AuthenticatedProjectProjectIdPlansRenameIndexRoute: typeof AuthenticatedProjectProjectIdPlansRenameIndexRoute
  AuthenticatedProjectProjectIdPlansUpgradeIndexRoute: typeof AuthenticatedProjectProjectIdPlansUpgradeIndexRoute
  AuthenticatedProjectProjectIdPlansExportPlanPlanIdIndexRoute: typeof AuthenticatedProjectProjectIdPlansExportPlanPlanIdIndexRoute
  AuthenticatedProjectProjectIdPlansImportRevisionPlanIdIndexRoute: typeof AuthenticatedProjectProjectIdPlansImportRevisionPlanIdIndexRoute
  AuthenticatedProjectProjectIdPlansPlanVersionsPlanIdIndexRoute: typeof AuthenticatedProjectProjectIdPlansPlanVersionsPlanIdIndexRoute
  AuthenticatedProjectProjectIdPlansMoveFolderItemIdIndexRoute: typeof AuthenticatedProjectProjectIdPlansMoveFolderItemIdIndexRoute
  AuthenticatedProjectProjectIdPlansMovePlanItemIdIndexRoute: typeof AuthenticatedProjectProjectIdPlansMovePlanItemIdIndexRoute
}

const AuthenticatedProjectProjectIdPlansRouteRouteChildren: AuthenticatedProjectProjectIdPlansRouteRouteChildren =
  {
    AuthenticatedProjectProjectIdPlansIndexRoute:
      AuthenticatedProjectProjectIdPlansIndexRoute,
    AuthenticatedProjectProjectIdPlansImportIndexRoute:
      AuthenticatedProjectProjectIdPlansImportIndexRoute,
    AuthenticatedProjectProjectIdPlansNewfolderIndexRoute:
      AuthenticatedProjectProjectIdPlansNewfolderIndexRoute,
    AuthenticatedProjectProjectIdPlansRenameIndexRoute:
      AuthenticatedProjectProjectIdPlansRenameIndexRoute,
    AuthenticatedProjectProjectIdPlansUpgradeIndexRoute:
      AuthenticatedProjectProjectIdPlansUpgradeIndexRoute,
    AuthenticatedProjectProjectIdPlansExportPlanPlanIdIndexRoute:
      AuthenticatedProjectProjectIdPlansExportPlanPlanIdIndexRoute,
    AuthenticatedProjectProjectIdPlansImportRevisionPlanIdIndexRoute:
      AuthenticatedProjectProjectIdPlansImportRevisionPlanIdIndexRoute,
    AuthenticatedProjectProjectIdPlansPlanVersionsPlanIdIndexRoute:
      AuthenticatedProjectProjectIdPlansPlanVersionsPlanIdIndexRoute,
    AuthenticatedProjectProjectIdPlansMoveFolderItemIdIndexRoute:
      AuthenticatedProjectProjectIdPlansMoveFolderItemIdIndexRoute,
    AuthenticatedProjectProjectIdPlansMovePlanItemIdIndexRoute:
      AuthenticatedProjectProjectIdPlansMovePlanItemIdIndexRoute,
  }

const AuthenticatedProjectProjectIdPlansRouteRouteWithChildren =
  AuthenticatedProjectProjectIdPlansRouteRoute._addFileChildren(
    AuthenticatedProjectProjectIdPlansRouteRouteChildren,
  )

interface AuthenticatedProjectProjectIdDatasetsRouteRouteChildren {
  AuthenticatedProjectProjectIdDatasetsIndexRoute: typeof AuthenticatedProjectProjectIdDatasetsIndexRoute
  AuthenticatedProjectProjectIdDatasetsDatasetIdIndexRoute: typeof AuthenticatedProjectProjectIdDatasetsDatasetIdIndexRoute
}

const AuthenticatedProjectProjectIdDatasetsRouteRouteChildren: AuthenticatedProjectProjectIdDatasetsRouteRouteChildren =
  {
    AuthenticatedProjectProjectIdDatasetsIndexRoute:
      AuthenticatedProjectProjectIdDatasetsIndexRoute,
    AuthenticatedProjectProjectIdDatasetsDatasetIdIndexRoute:
      AuthenticatedProjectProjectIdDatasetsDatasetIdIndexRoute,
  }

const AuthenticatedProjectProjectIdDatasetsRouteRouteWithChildren =
  AuthenticatedProjectProjectIdDatasetsRouteRoute._addFileChildren(
    AuthenticatedProjectProjectIdDatasetsRouteRouteChildren,
  )

interface AuthenticatedProjectProjectIdMediaRouteRouteChildren {
  AuthenticatedProjectProjectIdMediaIndexRoute: typeof AuthenticatedProjectProjectIdMediaIndexRoute
  AuthenticatedProjectProjectIdMediaGalleryYearMonthFileIdIndexRoute: typeof AuthenticatedProjectProjectIdMediaGalleryYearMonthFileIdIndexRoute
}

const AuthenticatedProjectProjectIdMediaRouteRouteChildren: AuthenticatedProjectProjectIdMediaRouteRouteChildren =
  {
    AuthenticatedProjectProjectIdMediaIndexRoute:
      AuthenticatedProjectProjectIdMediaIndexRoute,
    AuthenticatedProjectProjectIdMediaGalleryYearMonthFileIdIndexRoute:
      AuthenticatedProjectProjectIdMediaGalleryYearMonthFileIdIndexRoute,
  }

const AuthenticatedProjectProjectIdMediaRouteRouteWithChildren =
  AuthenticatedProjectProjectIdMediaRouteRoute._addFileChildren(
    AuthenticatedProjectProjectIdMediaRouteRouteChildren,
  )

interface AuthenticatedProjectProjectIdReportsRouteRouteChildren {
  AuthenticatedProjectProjectIdReportsReportIdIndexRoute: typeof AuthenticatedProjectProjectIdReportsReportIdIndexRoute
  AuthenticatedProjectProjectIdReportsNewReportIndexRoute: typeof AuthenticatedProjectProjectIdReportsNewReportIndexRoute
  AuthenticatedProjectProjectIdReportsShareReportIdIndexRoute: typeof AuthenticatedProjectProjectIdReportsShareReportIdIndexRoute
}

const AuthenticatedProjectProjectIdReportsRouteRouteChildren: AuthenticatedProjectProjectIdReportsRouteRouteChildren =
  {
    AuthenticatedProjectProjectIdReportsReportIdIndexRoute:
      AuthenticatedProjectProjectIdReportsReportIdIndexRoute,
    AuthenticatedProjectProjectIdReportsNewReportIndexRoute:
      AuthenticatedProjectProjectIdReportsNewReportIndexRoute,
    AuthenticatedProjectProjectIdReportsShareReportIdIndexRoute:
      AuthenticatedProjectProjectIdReportsShareReportIdIndexRoute,
  }

const AuthenticatedProjectProjectIdReportsRouteRouteWithChildren =
  AuthenticatedProjectProjectIdReportsRouteRoute._addFileChildren(
    AuthenticatedProjectProjectIdReportsRouteRouteChildren,
  )

interface AuthenticatedProjectProjectIdTasksRouteRouteChildren {
  AuthenticatedProjectProjectIdTasksIndexRoute: typeof AuthenticatedProjectProjectIdTasksIndexRoute
  AuthenticatedProjectProjectIdTasksNewIndexRoute: typeof AuthenticatedProjectProjectIdTasksNewIndexRoute
}

const AuthenticatedProjectProjectIdTasksRouteRouteChildren: AuthenticatedProjectProjectIdTasksRouteRouteChildren =
  {
    AuthenticatedProjectProjectIdTasksIndexRoute:
      AuthenticatedProjectProjectIdTasksIndexRoute,
    AuthenticatedProjectProjectIdTasksNewIndexRoute:
      AuthenticatedProjectProjectIdTasksNewIndexRoute,
  }

const AuthenticatedProjectProjectIdTasksRouteRouteWithChildren =
  AuthenticatedProjectProjectIdTasksRouteRoute._addFileChildren(
    AuthenticatedProjectProjectIdTasksRouteRouteChildren,
  )

interface AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRouteChildren {
  AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute
  AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute
  AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute
}

const AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRouteChildren: AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRouteChildren =
  {
    AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute:
      AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute,
    AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute:
      AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute,
    AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute:
      AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute,
  }

const AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRouteWithChildren =
  AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRoute._addFileChildren(
    AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRouteChildren,
  )

interface AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRouteChildren {
  AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRouteWithChildren
  AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskCreateTaskIndexRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskCreateTaskIndexRoute
  AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdGalleryPostIdFileIdIndexRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdGalleryPostIdFileIdIndexRoute
  AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskCreateTaskSelectAssigneeIndexRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskCreateTaskSelectAssigneeIndexRoute
  AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdAllVisualsGalleryPostIdFileIdIndexRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdAllVisualsGalleryPostIdFileIdIndexRoute
}

const AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRouteChildren: AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRouteChildren =
  {
    AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRoute:
      AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskTaskDetailsTaskIdRouteRouteWithChildren,
    AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskCreateTaskIndexRoute:
      AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskCreateTaskIndexRoute,
    AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdGalleryPostIdFileIdIndexRoute:
      AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdGalleryPostIdFileIdIndexRoute,
    AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskCreateTaskSelectAssigneeIndexRoute:
      AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdTaskCreateTaskSelectAssigneeIndexRoute,
    AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdAllVisualsGalleryPostIdFileIdIndexRoute:
      AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdAllVisualsGalleryPostIdFileIdIndexRoute,
  }

const AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRouteWithChildren =
  AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRoute._addFileChildren(
    AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRouteChildren,
  )

interface AuthenticatedProjectProjectIdPlanIdViewerRouteRouteChildren {
  AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRouteWithChildren
  AuthenticatedProjectProjectIdPlanIdViewerViewTypeIndexRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerViewTypeIndexRoute
}

const AuthenticatedProjectProjectIdPlanIdViewerRouteRouteChildren: AuthenticatedProjectProjectIdPlanIdViewerRouteRouteChildren =
  {
    AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRoute:
      AuthenticatedProjectProjectIdPlanIdViewerViewTypePinIdRouteRouteWithChildren,
    AuthenticatedProjectProjectIdPlanIdViewerViewTypeIndexRoute:
      AuthenticatedProjectProjectIdPlanIdViewerViewTypeIndexRoute,
  }

const AuthenticatedProjectProjectIdPlanIdViewerRouteRouteWithChildren =
  AuthenticatedProjectProjectIdPlanIdViewerRouteRoute._addFileChildren(
    AuthenticatedProjectProjectIdPlanIdViewerRouteRouteChildren,
  )

interface AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteChildren {
  AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute
  AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute
  AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute
}

const AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteChildren: AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteChildren =
  {
    AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute:
      AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute,
    AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute:
      AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute,
    AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute:
      AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute,
  }

const AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteWithChildren =
  AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRoute._addFileChildren(
    AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteChildren,
  )

interface AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRouteChildren {
  AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteWithChildren
  AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskCreateTaskIndexRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskCreateTaskIndexRoute
  AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdGalleryPostIdFileIdIndexRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdGalleryPostIdFileIdIndexRoute
  AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskCreateTaskSelectAssigneeIndexRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskCreateTaskSelectAssigneeIndexRoute
  AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdAllVisualsGalleryPostIdFileIdIndexRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdAllVisualsGalleryPostIdFileIdIndexRoute
}

const AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRouteChildren: AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRouteChildren =
  {
    AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRoute:
      AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteWithChildren,
    AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskCreateTaskIndexRoute:
      AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskCreateTaskIndexRoute,
    AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdGalleryPostIdFileIdIndexRoute:
      AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdGalleryPostIdFileIdIndexRoute,
    AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskCreateTaskSelectAssigneeIndexRoute:
      AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdTaskCreateTaskSelectAssigneeIndexRoute,
    AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdAllVisualsGalleryPostIdFileIdIndexRoute:
      AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdAllVisualsGalleryPostIdFileIdIndexRoute,
  }

const AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRouteWithChildren =
  AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRoute._addFileChildren(
    AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRouteChildren,
  )

interface AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRouteChildren {
  AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute
  AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute
  AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute
}

const AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRouteChildren: AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRouteChildren =
  {
    AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute:
      AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute,
    AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute:
      AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute,
    AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute:
      AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute,
  }

const AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRouteWithChildren =
  AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRoute._addFileChildren(
    AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRouteChildren,
  )

interface AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRouteChildren {
  AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRouteWithChildren
  AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskCreateTaskIndexRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskCreateTaskIndexRoute
  AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdGalleryPostIdFileIdIndexRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdGalleryPostIdFileIdIndexRoute
  AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskCreateTaskSelectAssigneeIndexRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskCreateTaskSelectAssigneeIndexRoute
  AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdAllVisualsGalleryPostIdFileIdIndexRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdAllVisualsGalleryPostIdFileIdIndexRoute
}

const AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRouteChildren: AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRouteChildren =
  {
    AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRoute:
      AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskTaskDetailsTaskIdRouteRouteWithChildren,
    AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskCreateTaskIndexRoute:
      AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskCreateTaskIndexRoute,
    AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdGalleryPostIdFileIdIndexRoute:
      AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdGalleryPostIdFileIdIndexRoute,
    AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskCreateTaskSelectAssigneeIndexRoute:
      AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdTaskCreateTaskSelectAssigneeIndexRoute,
    AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdAllVisualsGalleryPostIdFileIdIndexRoute:
      AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdAllVisualsGalleryPostIdFileIdIndexRoute,
  }

const AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRouteWithChildren =
  AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRoute._addFileChildren(
    AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRouteChildren,
  )

interface AuthenticatedProjectProjectIdPinsViewTypeRouteRouteChildren {
  AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRouteWithChildren
  AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRouteWithChildren
  AuthenticatedProjectProjectIdPinsViewTypePlanIdIndexRoute: typeof AuthenticatedProjectProjectIdPinsViewTypePlanIdIndexRoute
  AuthenticatedProjectProjectIdPinsViewTypeNoPlanIndexRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeNoPlanIndexRoute
}

const AuthenticatedProjectProjectIdPinsViewTypeRouteRouteChildren: AuthenticatedProjectProjectIdPinsViewTypeRouteRouteChildren =
  {
    AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRoute:
      AuthenticatedProjectProjectIdPinsViewTypePlanIdPinIdRouteRouteWithChildren,
    AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRoute:
      AuthenticatedProjectProjectIdPinsViewTypeNoPlanPinIdRouteRouteWithChildren,
    AuthenticatedProjectProjectIdPinsViewTypePlanIdIndexRoute:
      AuthenticatedProjectProjectIdPinsViewTypePlanIdIndexRoute,
    AuthenticatedProjectProjectIdPinsViewTypeNoPlanIndexRoute:
      AuthenticatedProjectProjectIdPinsViewTypeNoPlanIndexRoute,
  }

const AuthenticatedProjectProjectIdPinsViewTypeRouteRouteWithChildren =
  AuthenticatedProjectProjectIdPinsViewTypeRouteRoute._addFileChildren(
    AuthenticatedProjectProjectIdPinsViewTypeRouteRouteChildren,
  )

interface AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteChildren {
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute
}

const AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteChildren: AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteChildren =
  {
    AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute:
      AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdChangeAssigneeIndexRoute,
    AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute:
      AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdEditCommentIdIndexRoute,
    AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute:
      AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdCommentGalleryFileIdCommentIdIndexRoute,
  }

const AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteWithChildren =
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRoute._addFileChildren(
    AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteChildren,
  )

interface AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRouteChildren {
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteWithChildren
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskCreateTaskIndexRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskCreateTaskIndexRoute
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdGalleryPostIdFileIdIndexRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdGalleryPostIdFileIdIndexRoute
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskCreateTaskSelectAssigneeIndexRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskCreateTaskSelectAssigneeIndexRoute
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdAllVisualsGalleryPostIdFileIdIndexRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdAllVisualsGalleryPostIdFileIdIndexRoute
}

const AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRouteChildren: AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRouteChildren =
  {
    AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRoute:
      AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskTaskDetailsTaskIdRouteRouteWithChildren,
    AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskCreateTaskIndexRoute:
      AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskCreateTaskIndexRoute,
    AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdGalleryPostIdFileIdIndexRoute:
      AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdGalleryPostIdFileIdIndexRoute,
    AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskCreateTaskSelectAssigneeIndexRoute:
      AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdTaskCreateTaskSelectAssigneeIndexRoute,
    AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdAllVisualsGalleryPostIdFileIdIndexRoute:
      AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdAllVisualsGalleryPostIdFileIdIndexRoute,
  }

const AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRouteWithChildren =
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRoute._addFileChildren(
    AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRouteChildren,
  )

interface AuthenticatedProjectProjectIdGroupsGroupIdViewTypeRouteRouteChildren {
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypeIndexRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypeIndexRoute
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRouteWithChildren
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdIndexRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdIndexRoute
}

const AuthenticatedProjectProjectIdGroupsGroupIdViewTypeRouteRouteChildren: AuthenticatedProjectProjectIdGroupsGroupIdViewTypeRouteRouteChildren =
  {
    AuthenticatedProjectProjectIdGroupsGroupIdViewTypeIndexRoute:
      AuthenticatedProjectProjectIdGroupsGroupIdViewTypeIndexRoute,
    AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRoute:
      AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdPinIdRouteRouteWithChildren,
    AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdIndexRoute:
      AuthenticatedProjectProjectIdGroupsGroupIdViewTypePlanIdIndexRoute,
  }

const AuthenticatedProjectProjectIdGroupsGroupIdViewTypeRouteRouteWithChildren =
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypeRouteRoute._addFileChildren(
    AuthenticatedProjectProjectIdGroupsGroupIdViewTypeRouteRouteChildren,
  )

interface AuthenticatedProjectProjectIdRouteRouteChildren {
  AuthenticatedProjectProjectIdPlansRouteRoute: typeof AuthenticatedProjectProjectIdPlansRouteRouteWithChildren
  AuthenticatedProjectProjectIdDatasetsRouteRoute: typeof AuthenticatedProjectProjectIdDatasetsRouteRouteWithChildren
  AuthenticatedProjectProjectIdMediaRouteRoute: typeof AuthenticatedProjectProjectIdMediaRouteRouteWithChildren
  AuthenticatedProjectProjectIdReportsRouteRoute: typeof AuthenticatedProjectProjectIdReportsRouteRouteWithChildren
  AuthenticatedProjectProjectIdTasksRouteRoute: typeof AuthenticatedProjectProjectIdTasksRouteRouteWithChildren
  AuthenticatedProjectProjectIdPlanIdViewerRouteRoute: typeof AuthenticatedProjectProjectIdPlanIdViewerRouteRouteWithChildren
  AuthenticatedProjectProjectIdPinsViewTypeRouteRoute: typeof AuthenticatedProjectProjectIdPinsViewTypeRouteRouteWithChildren
  AuthenticatedProjectProjectIdGroupsIndexRoute: typeof AuthenticatedProjectProjectIdGroupsIndexRoute
  AuthenticatedProjectProjectIdTeamIndexRoute: typeof AuthenticatedProjectProjectIdTeamIndexRoute
  AuthenticatedProjectProjectIdGroupsGroupIdViewTypeRouteRoute: typeof AuthenticatedProjectProjectIdGroupsGroupIdViewTypeRouteRouteWithChildren
}

const AuthenticatedProjectProjectIdRouteRouteChildren: AuthenticatedProjectProjectIdRouteRouteChildren =
  {
    AuthenticatedProjectProjectIdPlansRouteRoute:
      AuthenticatedProjectProjectIdPlansRouteRouteWithChildren,
    AuthenticatedProjectProjectIdDatasetsRouteRoute:
      AuthenticatedProjectProjectIdDatasetsRouteRouteWithChildren,
    AuthenticatedProjectProjectIdMediaRouteRoute:
      AuthenticatedProjectProjectIdMediaRouteRouteWithChildren,
    AuthenticatedProjectProjectIdReportsRouteRoute:
      AuthenticatedProjectProjectIdReportsRouteRouteWithChildren,
    AuthenticatedProjectProjectIdTasksRouteRoute:
      AuthenticatedProjectProjectIdTasksRouteRouteWithChildren,
    AuthenticatedProjectProjectIdPlanIdViewerRouteRoute:
      AuthenticatedProjectProjectIdPlanIdViewerRouteRouteWithChildren,
    AuthenticatedProjectProjectIdPinsViewTypeRouteRoute:
      AuthenticatedProjectProjectIdPinsViewTypeRouteRouteWithChildren,
    AuthenticatedProjectProjectIdGroupsIndexRoute:
      AuthenticatedProjectProjectIdGroupsIndexRoute,
    AuthenticatedProjectProjectIdTeamIndexRoute:
      AuthenticatedProjectProjectIdTeamIndexRoute,
    AuthenticatedProjectProjectIdGroupsGroupIdViewTypeRouteRoute:
      AuthenticatedProjectProjectIdGroupsGroupIdViewTypeRouteRouteWithChildren,
  }

const AuthenticatedProjectProjectIdRouteRouteWithChildren =
  AuthenticatedProjectProjectIdRouteRoute._addFileChildren(
    AuthenticatedProjectProjectIdRouteRouteChildren,
  )

interface AuthenticatedProjectProjectsRouteRouteChildren {
  AuthenticatedProjectProjectsIndexRoute: typeof AuthenticatedProjectProjectsIndexRoute
  AuthenticatedProjectProjectsCopyIndexRoute: typeof AuthenticatedProjectProjectsCopyIndexRoute
  AuthenticatedProjectProjectsNewIndexRoute: typeof AuthenticatedProjectProjectsNewIndexRoute
  AuthenticatedProjectProjectsNewfolderIndexRoute: typeof AuthenticatedProjectProjectsNewfolderIndexRoute
  AuthenticatedProjectProjectsRenameIndexRoute: typeof AuthenticatedProjectProjectsRenameIndexRoute
  AuthenticatedProjectProjectsInfoProjectIdIndexRoute: typeof AuthenticatedProjectProjectsInfoProjectIdIndexRoute
  AuthenticatedProjectProjectsSettingsProjectIdIndexRoute: typeof AuthenticatedProjectProjectsSettingsProjectIdIndexRoute
  AuthenticatedProjectProjectsMoveFolderFolderIdIndexRoute: typeof AuthenticatedProjectProjectsMoveFolderFolderIdIndexRoute
  AuthenticatedProjectProjectsMoveProjectProjectIdIndexRoute: typeof AuthenticatedProjectProjectsMoveProjectProjectIdIndexRoute
}

const AuthenticatedProjectProjectsRouteRouteChildren: AuthenticatedProjectProjectsRouteRouteChildren =
  {
    AuthenticatedProjectProjectsIndexRoute:
      AuthenticatedProjectProjectsIndexRoute,
    AuthenticatedProjectProjectsCopyIndexRoute:
      AuthenticatedProjectProjectsCopyIndexRoute,
    AuthenticatedProjectProjectsNewIndexRoute:
      AuthenticatedProjectProjectsNewIndexRoute,
    AuthenticatedProjectProjectsNewfolderIndexRoute:
      AuthenticatedProjectProjectsNewfolderIndexRoute,
    AuthenticatedProjectProjectsRenameIndexRoute:
      AuthenticatedProjectProjectsRenameIndexRoute,
    AuthenticatedProjectProjectsInfoProjectIdIndexRoute:
      AuthenticatedProjectProjectsInfoProjectIdIndexRoute,
    AuthenticatedProjectProjectsSettingsProjectIdIndexRoute:
      AuthenticatedProjectProjectsSettingsProjectIdIndexRoute,
    AuthenticatedProjectProjectsMoveFolderFolderIdIndexRoute:
      AuthenticatedProjectProjectsMoveFolderFolderIdIndexRoute,
    AuthenticatedProjectProjectsMoveProjectProjectIdIndexRoute:
      AuthenticatedProjectProjectsMoveProjectProjectIdIndexRoute,
  }

const AuthenticatedProjectProjectsRouteRouteWithChildren =
  AuthenticatedProjectProjectsRouteRoute._addFileChildren(
    AuthenticatedProjectProjectsRouteRouteChildren,
  )

interface AuthenticatedProjectRouteRouteChildren {
  AuthenticatedProjectProjectIdRouteRoute: typeof AuthenticatedProjectProjectIdRouteRouteWithChildren
  AuthenticatedProjectProjectsRouteRoute: typeof AuthenticatedProjectProjectsRouteRouteWithChildren
}

const AuthenticatedProjectRouteRouteChildren: AuthenticatedProjectRouteRouteChildren =
  {
    AuthenticatedProjectProjectIdRouteRoute:
      AuthenticatedProjectProjectIdRouteRouteWithChildren,
    AuthenticatedProjectProjectsRouteRoute:
      AuthenticatedProjectProjectsRouteRouteWithChildren,
  }

const AuthenticatedProjectRouteRouteWithChildren =
  AuthenticatedProjectRouteRoute._addFileChildren(
    AuthenticatedProjectRouteRouteChildren,
  )

interface AuthenticatedUserManagementRouteRouteChildren {
  AuthenticatedUserManagementCompaniesIndexRoute: typeof AuthenticatedUserManagementCompaniesIndexRoute
  AuthenticatedUserManagementFolderRestrictionUserIdIndexRoute: typeof AuthenticatedUserManagementFolderRestrictionUserIdIndexRoute
  AuthenticatedUserManagementUserUserIdEditIndexRoute: typeof AuthenticatedUserManagementUserUserIdEditIndexRoute
}

const AuthenticatedUserManagementRouteRouteChildren: AuthenticatedUserManagementRouteRouteChildren =
  {
    AuthenticatedUserManagementCompaniesIndexRoute:
      AuthenticatedUserManagementCompaniesIndexRoute,
    AuthenticatedUserManagementFolderRestrictionUserIdIndexRoute:
      AuthenticatedUserManagementFolderRestrictionUserIdIndexRoute,
    AuthenticatedUserManagementUserUserIdEditIndexRoute:
      AuthenticatedUserManagementUserUserIdEditIndexRoute,
  }

const AuthenticatedUserManagementRouteRouteWithChildren =
  AuthenticatedUserManagementRouteRoute._addFileChildren(
    AuthenticatedUserManagementRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedProjectRouteRoute: typeof AuthenticatedProjectRouteRouteWithChildren
  AuthenticatedUserManagementRouteRoute: typeof AuthenticatedUserManagementRouteRouteWithChildren
  AuthenticatedSplatRoute: typeof AuthenticatedSplatRoute
  AuthenticatedHomeIndexRoute: typeof AuthenticatedHomeIndexRoute
  AuthenticatedReportTemplatesIndexRoute: typeof AuthenticatedReportTemplatesIndexRoute
  AuthenticatedUpgradeIndexRoute: typeof AuthenticatedUpgradeIndexRoute
  AuthenticatedUserSettingsIndexRoute: typeof AuthenticatedUserSettingsIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedProjectRouteRoute: AuthenticatedProjectRouteRouteWithChildren,
  AuthenticatedUserManagementRouteRoute:
    AuthenticatedUserManagementRouteRouteWithChildren,
  AuthenticatedSplatRoute: AuthenticatedSplatRoute,
  AuthenticatedHomeIndexRoute: AuthenticatedHomeIndexRoute,
  AuthenticatedReportTemplatesIndexRoute:
    AuthenticatedReportTemplatesIndexRoute,
  AuthenticatedUpgradeIndexRoute: AuthenticatedUpgradeIndexRoute,
  AuthenticatedUserSettingsIndexRoute: AuthenticatedUserSettingsIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface UnauthenticatedRouteRouteChildren {
  UnauthenticatedIdpSelectionIndexRoute: typeof UnauthenticatedIdpSelectionIndexRoute
  UnauthenticatedLoginIndexRoute: typeof UnauthenticatedLoginIndexRoute
  UnauthenticatedRegisterIndexRoute: typeof UnauthenticatedRegisterIndexRoute
  UnauthenticatedSamlLoginIndexRoute: typeof UnauthenticatedSamlLoginIndexRoute
  UnauthenticatedSsoSelectionIndexRoute: typeof UnauthenticatedSsoSelectionIndexRoute
  UnauthenticatedRegisterInvitedTokenIndexRoute: typeof UnauthenticatedRegisterInvitedTokenIndexRoute
  UnauthenticatedRegisterVerificationCodeIndexRoute: typeof UnauthenticatedRegisterVerificationCodeIndexRoute
  UnauthenticatedActivateTypeTokenIndexRoute: typeof UnauthenticatedActivateTypeTokenIndexRoute
}

const UnauthenticatedRouteRouteChildren: UnauthenticatedRouteRouteChildren = {
  UnauthenticatedIdpSelectionIndexRoute: UnauthenticatedIdpSelectionIndexRoute,
  UnauthenticatedLoginIndexRoute: UnauthenticatedLoginIndexRoute,
  UnauthenticatedRegisterIndexRoute: UnauthenticatedRegisterIndexRoute,
  UnauthenticatedSamlLoginIndexRoute: UnauthenticatedSamlLoginIndexRoute,
  UnauthenticatedSsoSelectionIndexRoute: UnauthenticatedSsoSelectionIndexRoute,
  UnauthenticatedRegisterInvitedTokenIndexRoute:
    UnauthenticatedRegisterInvitedTokenIndexRoute,
  UnauthenticatedRegisterVerificationCodeIndexRoute:
    UnauthenticatedRegisterVerificationCodeIndexRoute,
  UnauthenticatedActivateTypeTokenIndexRoute:
    UnauthenticatedActivateTypeTokenIndexRoute,
}

const UnauthenticatedRouteRouteWithChildren =
  UnauthenticatedRouteRoute._addFileChildren(UnauthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  UnauthenticatedRouteRoute: UnauthenticatedRouteRouteWithChildren,
  HomeModeIndexRoute: HomeModeIndexRoute,
  HomeModeTokenIndexRoute: HomeModeTokenIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
